export const tr = {
  // Sidebar groups
  sidebar: {
    superAdmin: 'Super Admin',
    allBrands: 'Tüm Markalar',
    brandPanel: 'Marka Paneli',
    managementPanel: 'Yönetim Paneli',
    mainMenu: 'Ana Menü',
    menuProducts: 'Menü & Ürünler',
    campaigns: 'Kampanyalar',
    reporting: 'Raporlama',
    customerService: 'Müşteri Hizmetleri',
    
    definitions: 'Tanımlar',
    operations: 'Operasyon',
    currentAccounts: 'Cari Yönetim',
    logs: 'Log',
  },
  // Sidebar items
  menu: {
    dashboard: 'Dashboard',
    orders: 'Siparişler',
    pastOrders: 'Geçmiş Siparişler',
    returnRequests: 'İade Talepleri',
    brands: 'Markalar',
    branches: 'Şubeler',
    users: 'Kullanıcılar',
    menuManagement: 'Menü Yönetimi',
    menuPackages: 'Menü Paketleri',
    recipeManagement: 'Reçete Yönetimi',
    campaignList: 'Kampanya Listesi',
    hqReport: 'Ana Merkez Raporu',
    salesReports: 'Satış Raporları',
    performance: 'Performans',
    advancedAnalysis: 'İleri Analiz',
    businessAnalytics: 'İş Analitiği',
    callCenterDashboard: 'Dashboard',
    crm: 'CRM',
    applications: 'Başvurular',
    supportTickets: 'Destek Talepleri',
    settings: 'Ayarlar',
    
    paymentDiscounts: 'Ödeme & İndirimler',
    warehouse: 'Depo',
    unitManagement: 'Birim Yönetimi',
    accounting: 'Muhasebe',
    dispatch: 'Sevkiyat',
    shipmentHistory: 'Sevkiyat Geçmişi',
    mysteryShopper: 'Gizli Müşteri',
    currentReportCard: 'Cari Karne',
    currentStatement: 'Cari Ekstre',
    invoices: 'Faturalar',
    payments: 'Ödemeler',
    returnManagement: 'İade Yönetimi',
    
    activityLogs: 'Aktivite Logları',
    branchMonitor: 'Bayi İzleme',
    financeManagement: 'Gelir/Gider Yönetimi',
  },
  // Dashboard filters
  filters: {
    branch: 'Şube',
    allBranches: 'Tüm Şubeler',
    unnamedBranch: 'İsimsiz Şube',
    reportType: 'Rapor Tipi',
    daily: 'Günlük',
    weekly: 'Haftalık',
    monthly: 'Aylık',
    custom: 'Özel Tarih',
    vat: 'KDV',
    vatIncluded: 'KDV Dahil',
    vatExcluded: 'KDV Hariç',
  },
  // Sales overview
  sales: {
    revenue: 'Satış Geliri',
    transactions: 'İşlem',
    branchCount: 'Şube Sayısı',
    activeBranches: 'Aktif şubeler',
    avgBasket: 'Ortalama Sepet',
    perOrder: 'Sipariş başına',
    productsPerBasket: 'Ürün/Sepet',
    avgProduct: 'Ortalama ürün',
    monthlyExpenses: 'Bu Ayki Giderler',
    thisMonth: 'Bu ay toplam',
    discount: 'İndirim',
    refund: 'İade',
    cancel: 'İptal',
    count: 'Adet',
    noData: 'Veri yok',
  },
  // Report filters
  reports: {
    consolidatedSalesReports: 'Konsolide Satış Raporları',
    salesDataFromAllBranches: 'Tüm şubelerden toplanan satış verileri',
    startDate: 'Başlangıç',
    endDate: 'Bitiş',
    pdfFailed: 'PDF oluşturulamadı. Lütfen tekrar deneyin.',
    refresh: 'Yenile',
  },
  // Common
  common: {
    loading: 'Yükleniyor...',
    error: 'Hata',
    save: 'Kaydet',
    cancel: 'İptal',
    delete: 'Sil',
    edit: 'Düzenle',
    create: 'Oluştur',
    search: 'Ara',
    export: 'Dışa Aktar',
    logout: 'Çıkış Yap',
    userMenu: 'Kullanıcı menüsü',
    toggleTheme: 'Tema değiştir',
    logoutError: 'Çıkış yapılırken bir hata oluştu.',
    user: 'Kullanıcı',
    close: 'Kapat',
    confirm: 'Onayla',
    deleteConfirmTitle: 'Silmek istediğinize emin misiniz?',
    deleteConfirmDesc: 'Bu işlem geri alınamaz. Kayıt kalıcı olarak silinecektir.',
    yes: 'Evet',
    no: 'Hayır',
    back: 'Geri',
    details: 'Detay',
    actions: 'Aksiyon',
    date: 'Tarih',
    status: 'Durum',
    amount: 'Tutar',
    total: 'Toplam',
    notes: 'Notlar',
    phone: 'Telefon',
    email: 'E-posta',
    password: 'Şifre',
    name: 'Ad',
    unknown: 'Bilinmiyor',
    notSet: 'Ayarlanmadı',
    notAssigned: 'Atanmamış',
    noPermission: 'Yetki yok',
    notSpecified: 'Belirtilmemiş',
    copiedToClipboard: 'Panoya kopyalandı',
    creating: 'Oluşturuluyor...',
    deleting: 'Siliniyor...',
    assigning: 'Atanıyor...',
    active: 'Aktif',
    passive: 'Pasif',
    today: 'Bugün',
    yesterday: 'Dün',
    daysAgo: '{count} gün önce',
    update: 'Güncelle',
    add: 'Ekle',
    uploading: 'Yükleniyor...',
    saving: 'Kaydediliyor...',
    description: 'Açıklama',
    optional: 'Opsiyonel',
    required: 'Zorunlu',
    all: 'Tümü',
    noResults: 'Sonuç bulunamadı',
    profit: 'kâr',
    loss: 'zarar',
    more: 'daha',
    queryError: {
      title: 'Veri yüklenemedi',
      retry: 'Tekrar dene',
    },
  },
  // Roles
  roles: {
    hqAdmin: 'HQ Admin',
    brandOwner: 'Marka Sahibi',
    branchManager: 'Şube Yöneticisi',
    branchStaff: 'Şube Personeli',
    accountant: 'Muhasebeci',
    dispatcher: 'Sevkiyatçı',
    mysteryShopper: 'Gizli Müşteri',
  },
  // Access denied
  access: {
    denied: 'Erişim Engellendi',
    noPermission: 'Bu sayfaya erişim yetkiniz bulunmamaktadır.',
    superAdminOnly: 'Bu sayfaya yalnızca Super Admin erişebilir.',
    checkingPermission: 'Yetki kontrol ediliyor...',
    panelLoading: 'Panel yükleniyor...',
  },
  // HQ Dashboard
  hqDashboard: {
    title: 'Merkez Yönetim Paneli',
    subtitle: 'Restoran zincirinizin operasyonlarını buradan yönetin',
    quickAccess: 'Hızlı Erişim',
    performance: 'Performans',
    branchPerformance: 'Şube performans takibi',
    brands: 'Markalar',
    restaurantBrands: 'Restoran markaları',
    branches: 'Şubeler',
    locationManagement: 'Lokasyon yönetimi',
    warehouse: 'Depo',
    stockSupplyManagement: 'Stok & tedarik yönetimi',
    orders: 'Siparişler',
    incomingOrders: 'Gelen siparişler',
    priceManagement: 'Fiyat Yönetimi',
    centralPricing: 'Merkezi fiyatlandırma',
    salesReports: 'Satış Raporları',
    consolidatedReporting: 'Konsolide raporlama',
    users: 'Kullanıcılar',
    roleManagement: 'Rol yönetimi',
    unassignedPackageWarning: '{count} şubenin menü paketi atanmamış. Ürünler şubede görüntülenemez.',
    unassignedBranches: 'Paket atanmamış şubeler: {names}',
    assignPackage: 'Paket Ata',
  },
  // Orders
  orders: {
    title: 'Gelen Siparişler',
    subtitle: 'Tüm şubelerden gelen B2B siparişleri',
    loading: 'Siparişler yükleniyor...',
    pending: 'Beklemede',
    approved: 'Onaylandı',
    preparing: 'Hazırlanıyor',
    shipped: 'Kargoda',
    delivered: 'Teslim Edildi',
    cancelled: 'İptal Edildi',
    noOrders: 'Henüz sipariş yok',
    noOrdersDesc: 'Şubelerden henüz sipariş gelmemiş.',
    orderList: 'Sipariş Listesi',
    orderListDesc: 'Son siparişler ve durumları',
    orderNo: 'Sipariş No',
    branch: 'Şube',
    products: 'Ürünler',
    status: 'Durum',
    action: 'İşlem',
    itemsCount: '{items} ürün, {qty} adet',
    approve: 'Onayla',
    cancel: 'İptal',
    cancelOrder: 'İptal Et',
    orderDetail: 'Sipariş Detayı',
    product: 'Ürün',
    quantity: 'Adet',
    unitPrice: 'B.Fiyat',
    approvedSuccess: 'Sipariş onaylandı',
    approvedError: 'Sipariş onaylanamadı',
    priceVarianceTitle: 'Fiyat farkı tespit edildi',
    priceVarianceDesc: 'Şubenin gönderdiği tutar ({branch}) ile merkez fiyat listesi ({hq}) arasında {diff} fark var. Onaylarsanız merkez fiyatı uygulanır ve cari hesaba bu tutar borç yazılır.',
    priceVarianceConfirm: 'Merkez fiyatıyla onayla',
    cancelledSuccess: 'Sipariş iptal edildi',
    cancelledError: 'Sipariş iptal edilemedi',
    success: 'Başarılı',
    currentAccount: 'Cari Hesap',
    currentBalance: 'Güncel Bakiye',
    riskLimit: 'Risk Limiti',
    viewCurrentAccount: 'Cari Hesaba Git',
    debt: 'Borç Var',
    credit: 'Alacak Var',
    balanced: 'Dengede',
    noAccount: 'Cari hesap bulunamadı',
  },
  // Brands
  brands: {
    title: 'Markalar',
    subtitle: 'Restoran zinciri marka yönetimi',
    loading: 'Markalar yükleniyor...',
    newBrand: 'Yeni Marka',
    noBrands: 'Henüz marka eklenmemiş',
    noBrandsDesc: 'Sisteme henüz bir marka kaydedilmemiş.',
    createFirst: 'İlk Markayı Oluştur',
    branchCount: '{count} şube',
    createdAt: 'Oluşturulma',
    createBrandUser: 'Marka Sahibi Kullanıcısı Oluştur',
    createBrandUserDesc: '{name} markası için giriş bilgileri oluşturun. Bu bilgilerle marka sahibi panele giriş yapabilecek.',
    userCreatedSuccess: 'Kullanıcı başarıyla oluşturuldu',
    saveCredentials: 'Bu bilgileri güvenli bir yere kaydedin. Şifre tekrar gösterilmeyecektir.',
    phoneNumber: 'Telefon Numarası',
    passwordMinLength: 'En az 6 karakter',
    createBrand: 'Yeni Marka Oluştur',
    createBrandDesc: 'Yeni bir restoran markası ekleyin. Marka oluşturulduktan sonra şubeler ekleyebilirsiniz.',
    brandName: 'Marka Adı',
    logoUrl: 'Logo URL (Opsiyonel)',
    editBrand: 'Markayı Düzenle',
    editBrandDesc: 'Marka bilgilerini güncelleyin.',
    deleteBrand: 'Markayı Silmek İstediğinize Emin Misiniz?',
    deleteBrandDesc: '{name} markası kalıcı olarak silinecektir. Bu işlem geri alınamaz. Bu markaya bağlı şubeler varsa silme işlemi başarısız olabilir.',
    yesDelete: 'Evet, Sil',
    createUserTitle: 'Marka sahibi kullanıcısı oluştur',
  },
  // Branches
  branches: {
    title: 'Şubeler',
    subtitle: 'Tüm şube lokasyonları ve performansları',
    loading: 'Şubeler yükleniyor...',
    totalBranches: 'Toplam Şube',
    avgPerformance: 'Ort. Performans',
    highPerformance: 'Yüksek Performans',
    needsAttention: 'Dikkat Gereken',
    noBranches: 'Henüz şube eklenmemiş',
    noBranchesDesc: 'Bu markaya henüz şube kaydedilmemiş. Şubeler adisyon sistemi üzerinden oluşturulur.',
    branchList: 'Şube Listesi',
    branchListDesc: 'Tüm aktif şubelerin detaylı listesi',
    branchName: 'Şube Adı',
    branchCode: 'Şube Kodu',
    permissions: 'Yetkiler',
    priceGroup: 'Fiyat Grubu',
    performance: 'Performans',
    registrationDate: 'Kayıt Tarihi',
    viewDetail: 'Detay Gör',
    price: 'Fiyat',
    product: 'Ürün',
    category: 'Kategori',
    stock: 'Stok',
    editBranch: 'Şubeyi Düzenle',
    editBranchDesc: 'Şube bilgilerini ve yetkilerini güncelleyin.',
    branchNameLabel: 'Şube Adı',
    branchCodeLabel: 'Şube Kodu (Opsiyonel)',
    branchNamePlaceholder: 'Örn: Kadıköy Şubesi',
    branchCodePlaceholder: 'Örn: IST-001',
    priceGroupSelect: 'Fiyat grubu seçin',
    basePrice: 'Atanmamış (Taban Fiyat)',
    priceGroupDesc: 'Şube, seçili grubun fiyatlarını kullanır.',
    branchPermissions: 'Şube Yetkileri',
    branchPermissionsDesc: 'Bu şubenin adisyon sisteminde yapabileceklerini belirleyin.',
    priceEdit: 'Fiyat Düzenleme',
    priceEditDesc: 'Şube, ürün fiyatlarını değiştirebilir.',
    productAdd: 'Ürün Ekleme',
    productAddDesc: 'Şube, kendi ürünlerini ekleyebilir.',
    categoryEdit: 'Kategori Düzenleme',
    categoryEditDesc: 'Şube, kategorileri düzenleyebilir.',
    stockToggle: 'Stok Açma/Kapama',
    stockToggleDesc: 'Şube, ürünleri açıp kapatabilir.',
    deleteBranch: 'Şubeyi Silmek İstediğinize Emin Misiniz?',
    deleteBranchDesc: '{name} şubesi kalıcı olarak silinecektir. Bu işlem geri alınamaz. Bu şubeye bağlı siparişler veya kullanıcılar varsa silme işlemi başarısız olabilir.',
    yesDelete: 'Evet, Sil',
    detailTitle: 'Şube detay bilgileri',
    ownerInfo: 'Sahip Bilgileri',
    fullName: 'Ad Soyad',
    billingInfo: 'Fatura Bilgileri',
    taxNo: 'Vergi No',
    city: 'Şehir',
    district: 'İlçe',
    address: 'Adres',
    noPermissionAssigned: 'Yetki atanmamış',
    applicationNote: 'Başvuru Notu',
    applicationDate: 'Başvuru',
    registration: 'Kayıt',
  },
  // Users
  users: {
    title: 'Kullanıcılar',
    subtitle: 'Sistem kullanıcıları ve rol yönetimi',
    loading: 'Kullanıcılar yükleniyor...',
    editRoles: 'Rolleri Düzenle',
    createUser: 'Kullanıcı Oluştur',
    noUsers: 'Henüz kullanıcı atanmamış',
    noUsersDesc: '"Kullanıcı Oluştur" butonunu kullanarak markanız için kullanıcı ekleyebilirsiniz.',
    userList: 'Kullanıcı Listesi',
    userListDesc: 'Markanıza ait kullanıcılar ve rolleri',
    user: 'Kullanıcı',
    role: 'Rol',
    brand: 'Marka',
    branch: 'Şube',
    assignmentDate: 'Atanma Tarihi',
    assignRole: 'Rol Ata',
    deleteRole: 'Rolü Silmek İstediğinize Emin Misiniz?',
    deleteRoleDesc: 'Bu işlem geri alınamaz. Kullanıcının {role} rolü kaldırılacak ve ilgili erişim yetkileri iptal edilecektir.',
    yesDelete: 'Evet, Sil',
    pendingUsers: 'Rol Bekleyen Kullanıcılar',
    pendingUsersDesc: 'Bu kullanıcılar sisteme kayıt olmuş ancak henüz rol atanmamış',
    username: 'Kullanıcı Adı',
    registrationDate: 'Kayıt Tarihi',
    editUser: 'Kullanıcı Düzenle',
    editUserDesc: 'Kullanıcı bilgilerini görüntüle ve düzenle',
    currentRole: 'Mevcut Rol',
    newPassword: 'Yeni Şifre',
    passwordEmpty: 'Boş bırakılırsa değişmez',
    passwordConfirm: 'Şifre Tekrar',
    passwordConfirmPlaceholder: 'Şifreyi tekrar girin',
    passwordMinError: 'Şifre en az 6 karakter olmalıdır',
    passwordMismatch: 'Şifreler eşleşmiyor',
    updateRequired: 'En az bir alan güncellenmelidir',
    updateSuccess: 'Kullanıcı başarıyla güncellendi',
    updateError: 'Güncelleme başarısız',
    createUserDialog: 'Yeni Kullanıcı Oluştur',
    createUserDialogDesc: 'Markanız için yeni bir kullanıcı oluşturun.',
    userCreated: 'Kullanıcı Oluşturuldu',
    userCreatedDesc: 'Aşağıdaki bilgileri kaydedin. Şifre tekrar gösterilmeyecektir.',
    copy: 'Kopyala',
    copied: 'Kopyalandı',
    infoCopied: 'Bilgiler panoya kopyalandı',
    phoneOptional: 'Telefon (opsiyonel)',
    roleSelect: 'Rol seçiniz',
    brandSelect: 'Marka seçiniz',
    branchOptional: 'Şube (opsiyonel)',
    allBranches: 'Tüm Şubeler',
    assignRoleTitle: 'Kullanıcıya Rol Ata',
  },
  // Applications
  applications: {
    title: 'Franchise Başvuruları',
    subtitle: 'Adisyon sisteminden gelen onay bekleyen franchise başvuruları',
    fullName: 'Ad Soyad',
    contact: 'İletişim',
    branchName: 'Şube Adı',
    location: 'Konum',
    status: 'Durum',
    date: 'Tarih',
    action: 'Aksiyon',
    detail: 'Detay',
    approve: 'Onayla',
    reject: 'Reddet',
    rejectTitle: 'Başvuruyu Reddet',
    rejectDesc: 'Bu başvuruyu reddetmek istediğinize emin misiniz? Başvuru kaydı silinecek ve kullanıcının franchise erişimi kaldırılacaktır. Bu işlem geri alınamaz.',
    yesReject: 'Evet, Reddet',
    detailTitle: 'Başvuru Detayı',
    statusNew: 'Yeni',
    statusContacted: 'İletişime Geçildi',
    statusInProgress: 'İşlemde',
    statusApproved: 'Onaylandı',
    statusRejected: 'Reddedildi',
    missingTaxWarning: 'Vergi numarası eksik. Fatura işlemleri için gereklidir.',
    personalInfo: 'Kişisel Bilgiler',
    taxNumber: 'Vergi Numarası',
    branchInfo: 'Şube Bilgileri',
    proposedBranchName: 'Önerilen Şube Adı',
    applicationInfo: 'Başvuru Bilgileri',
    applicationNote: 'Başvuru Notu',
    applicationDate: 'Başvuru Tarihi',
    approvalTitle: 'Başvuru Onaylandı',
    existingUserAssigned: 'Mevcut kullanıcıya şube başarıyla atandı.',
    newUserCreated: 'Yeni kullanıcı ve şube başarıyla oluşturuldu.',
    branchCode: 'Şube Kodu',
    existingUserNote: 'Bu kullanıcı zaten sisteme kayıtlı. Mevcut şifresiyle giriş yapabilir.',
    tempPassword: 'Geçici Şifre',
    shareWarning: 'Bu bilgileri şube yöneticisine güvenli bir şekilde iletin.',
    ok: 'Tamam',
  },
  // Menu Management
  menuMgmt: {
    title: 'Menü Yönetimi',
    subtitle: 'Franchise şubelerine gönderilecek menü ürünlerini, kategorilerini ve varyasyonlarını yönetin.',
    productsTab: 'Ürünler',
    categoriesTab: 'Kategoriler',
    variationsTab: 'Varyasyonlar',
    menuProducts: 'Menü Ürünleri',
    searchProduct: 'Ürün ara...',
    addProduct: 'Ürün Ekle',
    editProduct: 'Ürün Düzenle',
    newProduct: 'Yeni Ürün',
    productName: 'Ürün Adı',
    productNamePlaceholder: 'Ürün adı',
    basePrice: 'Taban Fiyat (₺)',
    calories: 'Kalori',
    stockCode: 'Stok Kodu',
    stockCodePlaceholder: 'Örn: PZ50',
    unit: 'Birim',
    categoryLabel: 'Kategori',
    categorySelect: 'Kategori seçin',
    uncategorized: 'Kategorisiz',
    productImage: 'Ürün Görseli',
    selectImage: 'Görsel Seç',
    variationGroups: 'Varyasyon Grupları',
    addToWarehouse: 'Bu ürünü depoya da eklemek ister misiniz?',
    addToWarehouseDesc: 'Aktif edilirse B2B tedarik ürünü olarak da oluşturulur',
    warehouseUnitPrice: 'Depo Birim Fiyatı (₺)',
    purchasePrice: 'Alış Fiyatı (₺)',
    stockQuantity: 'Stok Miktarı',
    minOrderQty: 'Min Sipariş Miktarı',
    orderIncrement: 'Sipariş Katı',
    criticalStock: 'Kritik Stok Eşiği',
    deleteProduct: 'Ürünü Sil',
    deleteProductDesc: 'Bu ürünü silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',
    noProducts: 'Ürün bulunamadı.',
    variation: 'varyasyon',
    addedToWarehouse: 'Ürün depoya da eklendi',
    warehouseError: 'Depo kaydı oluşturulamadı',
    // Categories
    categories: 'Kategoriler',
    addCategory: 'Kategori Ekle',
    editCategory: 'Kategori Düzenle',
    newCategory: 'Yeni Kategori',
    categoryName: 'Kategori Adı',
    categoryNamePlaceholder: 'Kategori adı',
    categoryImage: 'Kategori Görseli',
    noCategories: 'Henüz kategori eklenmemiş.',
    productCount: '{count} ürün',
    sortOrder: 'Sıra',
    deleteCategory: 'Kategoriyi Sil',
    deleteCategoryDesc: '"{name}" kategorisinde {count} ürün bulunuyor. Bu kategoriyi silmek istediğinizden emin misiniz?',
    duplicateCategory: 'Bu isimde bir kategori zaten mevcut.',
    // Variations
    variationPool: 'Varyasyon Havuzu',
    newGroupName: 'Yeni grup adı...',
    addGroup: 'Grup Ekle',
    noVariationGroups: 'Henüz varyasyon grubu eklenmemiş.',
    option: 'seçenek',
    optionName: 'Seçenek adı',
    priceCurrency: 'Fiyat (₺)',
    deleteGroup: 'Grubu Sil',
    deleteGroupDesc: '"{name}" grubundaki {count} seçenek de silinecek. Devam etmek istiyor musunuz?',
    duplicateGroup: 'Bu isimde bir grup zaten mevcut.',
    // ProductsTab additions
    normalView: 'Normal Görünüm',
    editOrder: 'Sıralamayı Düzenle',
    sku: 'SKU',
    variableProduct: 'Varyasyonlu ürün',
    variationCount: '{count} varyasyon',
    moreCount: '+{count} daha',
    editAria: 'Düzenle',
    deleteAria: 'Sil',
  },

  // Price Groups
  priceGroups: {
    title: 'Menü Paketleri',
    subtitle: 'Ürünleri paketler halinde yönetin, fiyatlandırın ve şubelere atayın.',
    packagesTab: 'Paketler',
    pricesTab: 'Ürün Seçimi & Fiyatlar',
    assignmentsTab: 'Şube Atamaları',
    packages: 'Menü Paketleri',
    packagesDesc: 'Her şube bir menü paketine atanır. Paketler hangi ürünlerin hangi fiyatla sunulacağını belirler.',
    addPackage: 'Paket Ekle',
    editPackage: 'Paketi Düzenle',
    newPackage: 'Yeni Menü Paketi',
    packageName: 'Paket Adı',
    packageNamePlaceholder: 'Örn: Standart Menü, Premium Menü',
    descriptionPlaceholder: 'Opsiyonel açıklama',
    defaultPackage: 'Varsayılan Paket',
    defaultPackageDesc: 'Yeni şubelere otomatik atanır.',
    defaultBadge: 'Varsayılan',
    assignedBranches: 'Atanmış Şube',
    editProducts: 'Ürünleri Düzenle',
    noPackages: 'Henüz menü paketi oluşturulmamış.',
    deletePackage: 'Menü Paketini Sil',
    deletePackageDesc: 'Bu paketi silmek istediğinizden emin misiniz? Pakete atanmış şubeler menüsüz kalacaktır.',
    createPackageFirst: 'Önce bir menü paketi oluşturun.',
    // Prices tab
    pricesTitle: 'Ürün Seçimi & Fiyatlar',
    pricesDesc: 'Pakete ürün ekleyin ve pakete özel fiyat belirleyin. Boş bırakılan fiyatlar taban fiyattan alınır.',
    savePrices: 'Fiyatları Kaydet',
    packageProducts: 'Paketteki Ürünler',
    noPackageProducts: 'Pakette henüz ürün yok. Aşağıdan ürün ekleyin.',
    catalogProducts: 'Katalogdaki Ürünler',
    addAll: 'Tümünü Ekle',
    allProductsAdded: 'Tüm ürünler pakete eklenmiş.',
    basePriceLabel: 'Taban Fiyat',
    dineIn: 'Masa (₺)',
    delivery: 'Paket (₺)',
    nothingToSave: 'Kaydedilecek ürün yok',
    // Assignments tab
    assignmentsTitle: 'Şube Atamaları',
    assignmentsDesc: 'Her şubeyi bir menü paketine atayın. Şube, atandığı paketin ürünlerini ve fiyatlarını kullanır.',
    noBranchesFound: 'Şube bulunamadı.',
    unassigned: 'Atanmamış (Menü Yok)',
    selectGroup: 'Grup seçin',
    searchBranch: 'Şube ara...',
    filterByPackage: 'Paket Filtresi',
    allPackages: 'Tümü',
    sortAZ: 'A → Z',
    sortZA: 'Z → A',
    branchesListed: '{count} şube listeleniyor',
  },
  // Recipes
  recipes: {
    title: 'Reçete Yönetimi',
    subtitle: 'Menü ürünleriniz için merkezi reçeteler tanımlayın',
    searchRecipe: 'Reçete ara...',
    newRecipe: 'Yeni Reçete',
    editRecipe: 'Reçete Düzenle',
    noRecipes: 'Henüz reçete oluşturulmamış',
    createFirst: 'İlk Reçeteyi Oluştur',
    classic: 'Klasik',
    withVariation: 'Varyasyonlu',
    ingredient: 'malzeme',
    deleteConfirm: 'Bu reçeteyi silmek istediğinizden emin misiniz?',
    menuProduct: 'Menü Ürünü',
    productSearch: 'Ürün ara...',
    selectProduct: 'Ürün seçin',
    recipeType: 'Reçete Tipi',
    variationSelection: 'Varyasyon Seçimi',
    ingredients: 'Malzemeler (Depo Ürünleri)',
    addRow: 'Satır Ekle',
    selectWarehouseProduct: 'Depo ürünü seçin',
    quantity: 'Miktar',
    noteOptional: 'Not (Opsiyonel)',
    autoConversion: 'Otomatik dönüşüm',
    // Ingredients
    ingredientsMgmt: 'Malzeme Yönetimi',
    searchIngredient: 'Malzeme ara...',
    newIngredient: 'Yeni Malzeme',
    editIngredient: 'Malzeme Düzenle',
    ingredientName: 'Malzeme Adı',
    unitLabel: 'Birim',
    unitCost: 'Birim Maliyet',
    warehouseProduct: 'Depo Ürünü',
    warehouseLinking: 'Depo Ürünü Eşleştirme (Opsiyonel)',
    noLinking: 'Eşleştirme Yok',
    noIngredients: 'Henüz malzeme eklenmemiş',
    deleteIngredientConfirm: 'Bu malzemeyi silmek istediğinizden emin misiniz?',
  },
  // Campaigns
  campaigns: {
    title: 'Kampanya Yönetimi',
    subtitle: 'Kampanyalar, sadakat programı ve çekilişleri yönetin',
    campaignsTab: 'Kampanyalar',
    loyaltyTab: 'Sadakat Ayarları',
    drawsTab: 'Çekilişler',
    loading: 'Kampanyalar yükleniyor...',
    campaignList: 'Kampanya Listesi',
    newCampaign: 'Yeni Kampanya',
    editCampaign: 'Kampanya Düzenle',
    campaignName: 'Kampanya Adı',
    campaignNamePlaceholder: 'Yaz İndirimi',
    campaignType: 'Kampanya Tipi',
    typeDiscount: 'İndirim',
    typePoints: 'Puan Kazandırma',
    typeBogo: '1 Alana 1 Bedava',
    startDate: 'Başlangıç',
    endDate: 'Bitiş',
    noCampaigns: 'Henüz kampanya tanımlanmamış',
    // Loyalty
    loyaltyTitle: 'Puan Sistemi Ayarları',
    pointRatio: '1 Puan = Kaç TL?',
    pointRatioHint: 'Örn: 0.1 = 10 puan = 1 TL',
    minBasket: 'Minimum Sepet Tutarı (TL)',
    minBasketHint: 'Puan kullanımı için gereken minimum sepet tutarı',
    loyaltyActive: 'Puan Sistemi Aktif',
    loyaltyActiveHint: 'Sistemin aktif olup olmadığını belirler',
    // Draws
    drawsTitle: 'Çekilişler',
    newDraw: 'Yeni Çekiliş',
    drawName: 'Çekiliş Adı',
    participationStart: 'Katılım Başlangıç',
    participationEnd: 'Katılım Bitiş',
    drawDate: 'Çekiliş Tarihi',
    noDraws: 'Henüz çekiliş tanımlanmamış',
  },
  // Sales Reports page
  salesReports: {
    title: 'Satış Raporları',
    subtitle: 'Konsolide şube performans analizi',
    preparingReports: 'Raporlar hazırlanıyor...',
    noReportData: 'Rapor verisi bulunamadı.',
    overviewTab: 'Genel Özet',
    collectionTab: 'Tahsilat & Ödeme',
    productsTab: 'Ürün Analizi',
    branchProductsTab: 'Şube Yerel Ürünleri',
    discountsTab: 'İndirim & Müşteri',
    operationsTab: 'Operasyon',
    branchComparison: 'Şube Karşılaştırması',
    noCollectionData: 'Tahsilat verisi bulunamadı.',
    noDiscountData: 'İndirim verisi bulunamadı.',
    noOperationData: 'Operasyon verisi bulunamadı.',
    branchFilter: 'Şube',
    allBranches: 'Tüm Şubeler',
    unnamedBranch: 'İsimsiz Şube',
    // SalesSummaryCards
    totalSales: 'Toplam Satış',
    orderCount: '{count} sipariş',
    cash: 'Nakit',
    card: 'Kart',
    avgOrder: 'Ort. Sipariş',
    perOrder: 'sipariş başına',
    foodCard: 'Yemek Kartı',
    totalDiscount: 'Toplam İndirim',
    serviceFee: 'Servis Ücreti',
    // SalesTable
    branchDetails: 'Şube Detayları',
    branchMetrics: 'Şube bazlı performans metrikleri',
    branch: 'Şube',
    order: 'Sipariş',
    sales: 'Satış',
    // External Platforms
    extPlatformsTab: 'Online Satış Platformları',
    noExternalData: 'Dış platform sipariş verisi bulunamadı.',
    extRevenue: 'Dış Platform Cirosu',
    extRevenueShare: 'Toplam cirodaki payı: %{pct}',
    extRevenueOfTotal: 'toplam cirodan',
    extOrders: 'Dış Platform Siparişleri',
    extCancelled: 'İptal Edilen',
    extCancelledShort: 'İptal',
    cancelRate: 'İptal Oranı',
    extAvgOrder: 'Ort. Sipariş',
    platform: 'Platform',
    platformBreakdown: 'Platform Kırılımı',
    branchPlatformMatrix: 'Şube × Platform Matrisi',
  },
  // Performance Dashboard
  performance: {
    title: 'Performans Paneli',
    subtitle: 'Tüm şubelerin performansını takip edin ve analiz edin',
    loadingData: 'Performans verileri yükleniyor...',
    totalBranches: 'Toplam Şube',
    activeBranch: 'Aktif şube',
    avgScore: 'Ortalama Puan',
    points100: '/ 100 puan',
    belowTarget: 'Hedef Altı',
    branchUnit: 'şube',
    criticalAlert: 'Kritik Uyarı',
    activeAlert: 'aktif uyarı',
    criticalAlerts: 'Kritik Uyarılar',
    perfAlertCount: '{count} performans uyarısı',
    stockAlertCount: '{count} stok uyarısı',
    and: ' ve ',
    urgentAttention: ' acil dikkat gerektiriyor.',
    rankingTab: 'Sıralama',
    alertsTab: 'Uyarılar',
    costsTab: 'Maliyet',
    targetsTab: 'Hedefler',
    mysteryTab: 'Gizli Müşteri',
    bestPerformance: 'En İyi Performans',
    needsImprovement: 'İyileştirme Gereken',
    // Leaderboard
    branchRanking: 'Şube Sıralaması',
    noPerformanceData: 'Henüz performans verisi bulunmuyor',
    // Alerts
    performanceAlerts: 'Performans Uyarıları',
    allBranchesOk: 'Tüm şubeler sorunsuz çalışıyor',
    newCount: '{count} yeni',
    severityCritical: 'Kritik',
    severityHigh: 'Yüksek',
    severityMedium: 'Orta',
    severityLow: 'Düşük',
    // Stock
    stockWarnings: 'Stok Uyarıları',
    unknownProduct: 'Bilinmeyen Ürün',
    orderLabel: 'Sipariş',
    shortageCount: '{count} adet eksik',
    requestedCount: 'İstenen: {count}',
    noStockWarnings: 'Aktif stok uyarısı bulunmuyor',
    // Cost
    costAnalysis: 'Maliyet Analizi',
    totalCost: 'Toplam Maliyet',
    supplyOrders: 'Tedarik Siparişleri',
    wasteLoss: 'Fire (Kayıp)',
    loss: 'Kayıp',
    other: 'Diğer',
    atRate: 'oranında',
    wasteRate: 'Fire Oranı',
    lossRate: 'Kayıp Oranı',
    costDistribution: 'Maliyet Dağılımı',
    detailedCostChart: 'Detaylı maliyet grafiği',
    dataWillAppear: 'Veri toplandıkça görüntülenecek',
    // Targets
    targetManagement: 'Hedef Yönetimi',
    addTarget: 'Hedef Ekle',
    unknownBranch: 'Bilinmeyen Şube',
    targetLabel: 'Hedef:',
    noTargets: 'Henüz hedef tanımlanmamış',
    addSalesTargets: 'Şubeler için satış hedefleri ekleyin',
    newTarget: 'Yeni Hedef Ekle',
    selectBranch: 'Şube seçin',
    allBranches: 'Tüm Şubeler',
    targetType: 'Hedef Tipi',
    selectTargetType: 'Hedef tipi seçin',
    dailySales: 'Günlük Satış',
    weeklySales: 'Haftalık Satış',
    monthlySales: 'Aylık Satış',
    orderCountTarget: 'Sipariş Sayısı',
    avgOrderValue: 'Ort. Sipariş Değeri',
    targetValue: 'Hedef Değeri',
    amountPlaceholder: '₺ tutar',
    countPlaceholder: 'Adet',
    adding: 'Ekleniyor...',
    // Score card
    salesLabel: 'Satış',
    targetLabel2: 'Hedef',
    orderLabel2: 'Sipariş',
    growthLabel: 'Büyüme',
    stable: 'Sabit',
    point: 'puan',
    // Mystery
    avgScoreLabel: 'Ortalama Puan',
    evaluationLabel: 'Değerlendirme',
    totalLabel: 'toplam',
    bestLabel: 'En İyi',
    noMysteryReviews: 'Henüz gizli müşteri değerlendirmesi bulunmuyor',
    branchEvaluations: 'Şube Bazlı Değerlendirmeler',
    overall: 'Genel',
    cleanliness: 'Temizlik',
    service: 'Hizmet',
    foodQuality: 'Yemek',
    waitTime: 'Bekleme',
    evalCount: 'Değ. Sayısı',
    minutes: 'dk',
    recentReviews: 'Son Değerlendirmeler',
  },
  // HQ Center Report
  hqReport: {
    title: 'Ana Merkez Raporu',
    unassignedWarning: '{count} sipariş bir şubeye bağlanamadı ({amount}) ve toplamlara dahil edilmedi.',
    subtitle: 'Merkezin şubelere yaptığı B2B satış verileri',
    startLabel: 'Başlangıç',
    endLabel: 'Bitiş',
    totalRevenue: 'Toplam Ciro',
    deliveredOrders: 'Teslim edilen siparişler',
    totalOrders: 'Toplam Sipariş',
    allOrders: 'Tüm siparişler',
    avgOrderAmount: 'Ort. Sipariş Tutarı',
    perOrder: 'Sipariş başına',
    pending: 'Bekleyen',
    awaitingApproval: 'Onay bekliyor',
    cancelled: 'İptal Edilen',
    cancelledOrders: 'İptal siparişleri',
    returnsDeducted: 'İadeler düşülmüş',
    totalReturns: 'Toplam İade',
    returnCount: 'iade talebi',
    overviewTab: 'Genel Bakış',
    branchesTab: 'Şube Bazlı',
    productsTab: 'Ürün Bazlı',
    statusTab: 'Durum Dağılımı',
    dailySalesTrend: 'Günlük Satış Trendi',
    branchRevenue: 'Şube Bazlı Ciro',
    noData: 'Veri bulunamadı.',
    branchHead: 'Şube',
    orderCount: 'Sipariş Sayısı',
    totalRevenueHead: 'Toplam Ciro',
    avgAmount: 'Ort. Tutar',
    product: 'Ürün',
    totalQuantity: 'Toplam Adet',
    orderStatus: 'Sipariş Durumu',
    paymentStatus: 'Ödeme Durumu',
    revenue: 'Ciro',
    statusPending: 'Beklemede',
    statusApproved: 'Onaylandı',
    statusPreparing: 'Hazırlanıyor',
    statusShipped: 'Kargoda',
    statusDelivered: 'Teslim Edildi',
    statusCancelled: 'İptal',
    paymentPending: 'Beklemede',
    paymentPaid: 'Ödendi',
    paymentInvoiced: 'Faturalandı',
    paymentCancelled: 'İptal',
    paymentNotSpecified: 'Belirtilmemiş',
  },
  // Advanced Reports
  advancedReports: {
    title: 'İleri Düzey Raporlar',
    subtitle: 'Detaylı satış analizleri ve performans metrikleri',
    hourlyTab: 'Saatlik Analiz',
    cancellationsTab: 'İptaller',
    paymentsTab: 'Ödeme Dağılımı',
    hourlyHeatmap: 'Saatlik Satış Isı Haritası',
    multiBranch: 'Çoklu Şube',
    selectBranch: 'Şube seçin',
    allBranches: 'Tüm Şubeler',
    unnamed: 'İsimsiz',
    unnamedBranch: 'İsimsiz Şube',
    allTime: 'Tüm Zamanlar',
    today: 'Bugün',
    thisWeek: 'Bu Hafta',
    thisMonth: 'Bu Ay',
    thisYear: 'Bu Yıl',
    customRange: 'Özel Tarih Aralığı',
    branchCount: '{count} şube',
    previous: '← Önceki',
    next: 'Sonraki →',
    noSalesData: 'Satış verisi bulunamadı.',
    low: 'Düşük',
    medium: 'Orta',
    high: 'Yüksek',
    orderAbbrev: 'sip.',
    noBranchFound: 'Şube bulunamadı.',
    cancelledOrders: 'İptal Edilen Siparişler',
    cancelDataNotAvailable: 'İptal verisi henüz mevcut değil. Bu özellik, iptal kayıtları veritabanına eklendiğinde aktif olacaktır.',
    paymentDistribution: 'Ödeme Yöntemi Dağılımı',
    total: 'Toplam',
    noPaymentData: 'Seçilen dönem için ödeme verisi bulunamadı.',
    reportsLoading: 'Raporlar yükleniyor...',
    noPaymentDataFound: 'Ödeme verisi bulunamadı.',
    orderTypeAll: 'Tüm Siparişler',
    orderTypeDineIn: 'Masa Siparişleri',
    orderTypeDelivery: 'Online Siparişler',
    orderTypeTakeaway: 'Gel-Al Siparişleri',
    detailOrderCount: 'Sipariş',
    detailRevenue: 'Ciro',
    detailOrderTypes: 'Sipariş Türleri',
    detailPaymentMethods: 'Ödeme Yöntemleri',
    detailDiscounts: 'İndirimler',
    detailDiscountedOrders: 'indirimli sipariş',
    detailOrderList: 'Sipariş Listesi',
    detailPayment: 'Ödeme',
    detailNoItems: 'Ürün detayı bulunamadı',
  },
  // Call Center
  callCenter: {
    title: 'Müşteri Hizmetleri',
    defaultSubject: 'Destek talebi',
    subtitle: 'Destek talepleri ve CRM özeti',
    loading: 'Müşteri hizmetleri yükleniyor...',
    openTickets: 'Açık Talepler',
    inProgress: 'İşlemde',
    openedToday: 'Bugün Açılan',
    avgResolution: 'Ort. Çözüm',
    hours: 'sa',
    pendingApps: 'Bekleyen Başvuru',
    highPriority: 'Yüksek Öncelik',
    recentTickets: 'Son Talepler',
    allTickets: 'Tümü',
    noTickets: 'Henüz destek talebi yok',
    agentWorkload: 'Agent İş Yükü',
    manage: 'Yönet',
    noActiveAgents: 'Aktif agent yok',
    openCount: 'açık',
    crmApplications: 'CRM & Başvurular',
    totalApplications: 'toplam başvuru',
    supportTickets: 'Destek Talepleri',
    totalTickets: 'toplam talep',
    priorityHigh: 'Yüksek',
    priorityMedium: 'Orta',
    priorityLow: 'Düşük',
    // Tickets page
    ticketsTitle: 'Destek Talepleri',
    ticketsSubtitle: 'Şikayet ve destek taleplerini yönetin',
    ticketsLoading: 'Destek talepleri yükleniyor...',
    statusOpen: 'Açık',
    statusInProgress: 'İşlemde',
    statusResolved: 'Çözüldü',
    statusClosed: 'Kapatıldı',
    // Tickets table
    ticketCount: 'Destek Talepleri',
    newTicket: 'Yeni Talep',
    searchTicket: 'Konu veya müşteri ile ara...',
    allStatuses: 'Tüm Durumlar',
    allPriorities: 'Tüm Öncelikler',
    subject: 'Konu',
    branch: 'Şube',
    category: 'Kategori',
    priority: 'Öncelik',
    status: 'Durum',
    assignedAgent: 'Atanan',
    date: 'Tarih',
    action: 'İşlem',
    noTicketsFound: 'Destek talebi bulunamadı',
    unassigned: 'Atanmadı',
    assign: 'Ata...',
    takeInProgress: 'İşleme Al',
    markResolved: 'Çözüldü Olarak İşaretle',
    close: 'Kapat',
    // Ticket detail
    ticketDetail: 'Talep Detayı',
    actions: 'İşlemler',
    assignedAgentLabel: 'Atanan Agent',
    customerInfo: 'Müşteri Bilgileri',
    fullName: 'Ad Soyad',
    ticketInfo: 'Talep Bilgileri',
    topic: 'Konu',
    descriptionLabel: 'Açıklama',
    dates: 'Tarihler',
    createdAt: 'Oluşturulma',
    resolvedAt: 'Çözülme',
    // Ticket form
    newTicketForm: 'Yeni Destek Talebi',
    selectBranch: 'Şube seçin...',
    selectCategory: 'Kategori seçin...',
    selectTopic: 'Konu seçin...',
    customerName: 'Müşteri Adı',
    customerSurname: 'Müşteri Soyadı',
    city: 'İl',
    district: 'İlçe',
    subjectRequired: 'Konu *',
    subjectPlaceholder: 'Şikayetin konusunu yazın',
    descriptionPlaceholder: 'Detaylı açıklama...',
    // Applications page
    appTitle: 'Başvuru Yönetimi',
    appSubtitle: 'Bayi ve franchise başvurularını takip edin',
    appLoading: 'Başvurular yükleniyor...',
    statusNew: 'Yeni',
    statusContacted: 'İletişime Geçildi',
    statusApproved: 'Onaylandı',
    statusRejected: 'Reddedildi',
    applicationsTab: 'Başvurular',
    metricsTab: 'Metrikler',
    resultsTab: 'Sonuçlar',
    // Applications table
    applicationsCount: 'Başvurular',
    newApplication: 'Yeni Başvuru',
    searchApp: 'İsim, telefon veya email ile ara...',
    allTypes: 'Tüm Tipler',
    typeDealer: 'Bayi',
    typeFranchise: 'Franchise',
    typeRental: 'Kiralık Yer',
    typeDelivery: 'Paket Taşıma',
    typeDealerFull: 'Bayi Başvurusu',
    typeFranchiseFull: 'Franchise Başvurusu',
    typeRentalFull: 'Kiralık Yer Önerisi',
    typeDeliveryFull: 'Paket Taşıma Hizmeti',
    proposedBranch: 'Önerilen Şube',
    contact: 'İletişim',
    location: 'Konum',
    noApplications: 'Başvuru bulunamadı',
    approve: 'Onayla',
    approveManual: 'Onayla (Manuel)',
    contacted: 'İletişime Geçildi',
    reject: 'Reddet',
    viewDetail: 'Detay Gör',
    // Application detail
    appDetail: 'Başvuru Detayı',
    personalInfo: 'Kişisel Bilgiler',
    businessInfo: 'İşletme Bilgileri',
    taxNumber: 'Vergi Numarası',
    proposedBranchName: 'Önerilen Şube Adı',
    notesLabel: 'Notlar',
    locationLabel: 'Konum',
    approvalInfo: 'Onay Bilgileri',
    createdBranch: 'Oluşturulan Şube',
    branchCode: 'Şube Kodu',
    // CRM Metrics
    totalApps: 'Toplam Başvuru',
    conversionRate: 'Dönüşüm Oranı',
    avgProcessing: 'Ort. İşlem Süresi',
    days: 'gün',
    pending: 'Bekleyen',
    monthlyTrend: 'Aylık Başvuru Trendi',
    applicationLabel: 'Başvuru',
    statusDistribution: 'Durum Dağılımı',
    cityDistribution: 'Şehir Bazlı Dağılım',
    cityHead: 'Şehir',
    appCount: 'Başvuru',
    ratio: 'Oran',
    typeDistribution: 'Başvuru Tipi Dağılımı',
    typeHead: 'Tip',
    // CRM Results
    approved: 'Onaylanan',
    rejected: 'Reddedilen',
    approvedApps: 'Onaylanan Başvurular',
    noApproved: 'Henüz onaylanan başvuru yok.',
    applicant: 'Başvuran',
    duration: 'Süre',
    rejectedApps: 'Reddedilen Başvurular',
    noRejected: 'Henüz reddedilen başvuru yok.',
    note: 'Not',
    // Settings page
    settingsTitle: 'Call Center Ayarları',
    settingsSubtitle: 'Agent ve kategori tanımlamaları',
    settingsLoading: 'Ayarlar yükleniyor...',
    agentsTab: 'Agent Listesi',
    categoriesTab: 'Kategoriler',
    questionsTab: 'Başvuru Soruları',
  },
  // Definitions
  definitions: {
    title: 'Sistem Tanımları',
    subtitle: 'Ödeme yöntemleri ve indirim tanımlarını yönetin',
    refreshing: 'Yenileniyor...',
    loading: 'Tanımlar yükleniyor...',
    paymentTab: 'Ödeme Yöntemleri',
    discountTab: 'İndirim Tanımları',
    // Payment methods
    totalMethods: 'Toplam Yöntem',
    activeMethods: 'Aktif',
    cashMethods: 'Nakit Yöntem',
    paymentMethods: 'Ödeme Yöntemleri',
    newMethod: 'Yeni Yöntem',
    order: 'Sıra',
    methodName: 'Yöntem Adı',
    code: 'Kod',
    commissionPct: 'Komisyon %',
    cash: 'Nakit',
    noPaymentMethods: 'Henüz ödeme yöntemi tanımlanmamış',
    editPaymentMethod: 'Ödeme Yöntemi Düzenle',
    newPaymentMethod: 'Yeni Ödeme Yöntemi',
    editPaymentMethodDesc: 'Mevcut ödeme yöntemini düzenleyin.',
    newPaymentMethodDesc: 'Yeni bir ödeme yöntemi tanımlayın.',
    methodNameLabel: 'Yöntem Adı *',
    codeLabel: 'Kod *',
    commissionRate: 'Komisyon Oranı (%)',
    cashPayment: 'Nakit Ödeme',
    deletePaymentTitle: 'Ödeme yöntemini silmek istediğinize emin misiniz?',
    deletePaymentDesc: '{name} ({code}) yöntemi kalıcı olarak silinecektir. Bu işlem geri alınamaz.',
    // Discounts
    totalDiscounts: 'Toplam İndirim',
    activeDiscounts: 'Aktif İndirim',
    percentageFixed: 'Yüzde / Sabit',
    discountDefinitions: 'İndirim Tanımları',
    newDiscount: 'Yeni İndirim',
    discountName: 'İndirim Adı',
    typeLabel: 'Tip',
    rateAmount: 'Oran/Tutar',
    minBasket: 'Min Sepet',
    percentage: 'Yüzde',
    fixed: 'Sabit',
    noDiscounts: 'Henüz indirim tanımı yapılmamış',
    editDiscount: 'İndirim Düzenle',
    newDiscountDialog: 'Yeni İndirim Tanımı',
    editDiscountDesc: 'Mevcut indirim tanımını düzenleyin.',
    newDiscountDesc: 'Yeni bir indirim tanımı oluşturun.',
    discountNameLabel: 'İndirim Adı *',
    discountCodeLabel: 'Kod *',
    discountType: 'Tip',
    percentageType: 'Yüzde (%)',
    fixedType: 'Sabit Tutar (TL)',
    ratePct: 'Oran (%)',
    rateTL: 'Tutar (TL)',
    maxDiscount: 'Max İndirim (TL)',
    minBasketLabel: 'Min Sepet (TL)',
    deleteDiscountTitle: 'İndirimi silmek istediğinize emin misiniz?',
    deleteDiscountDesc: '{name} ({code}) indirimi kalıcı olarak silinecektir. Bu işlem geri alınamaz.',
  },
  // Warehouse
  warehouse: {
    title: 'Depo Yönetimi',
    subtitle: 'Merkez depo stok takibi ve ürün yönetimi',
    loading: 'Depo yükleniyor...',
    addProduct: 'Yeni Ürün Ekle',
    productUpdated: 'Ürün güncellendi',
    productAddedMenu: 'Ürün depoya ve menüye eklendi',
    productAdded: 'Ürün eklendi',
    menuProductError: 'Depo ürünü eklendi ancak menü ürünü oluşturulamadı',
    operationFailed: 'İşlem başarısız',
    deleteConfirm: 'Bu ürünü silmek istediğinize emin misiniz?',
    productDeleted: 'Ürün silindi',
    deleteFailed: 'Silme işlemi başarısız',
    stockUpdated: 'Stok güncellendi',
    stockUpdateFailed: 'Stok güncelleme başarısız',
    readyProductCategory: 'Hazır ürün için kategori seçimi zorunludur',
    readyProductPrice: 'Hazır ürün için menü fiyatı zorunludur',
    // Product form dialog
    editProductTitle: 'Ürün Düzenle',
    addProductTitle: 'Yeni Ürün Ekle',
    formDesc: 'Depo ürün bilgilerini girin',
    productName: 'Ürün Adı',
    stockCodeSku: 'Stok Kodu (SKU)',
    purchasePrice: 'Alış Fiyatı (₺)',
    sellPrice: 'Satış Fiyatı (₺)',
    saleUnit: 'Satış Birimi',
    currentStock: 'Mevcut Stok',
    minOrder: 'Minimum Sipariş',
    orderIncrement: 'Sipariş Katları',
    criticalThreshold: 'Kritik Stok Eşiği',
    criticalHint: 'Bu seviyenin altına düşünce uyarı verilir (0 = devre dışı)',
    isReadyProductQuestion: 'Bu ürün hazır ürün mü?',
    alreadyInMenu: 'Bu ürün zaten menüye eklenmiş',
    addToMenuQuestion: 'Menünüze bu ürünü direkt eklemek ister misiniz?',
    menuCategory: 'Menü Kategorisi',
    menuSellPrice: 'Menü Satış Fiyatı (₺)',
    menuSellPricePlaceholder: 'Şubelere yansıyacak fiyat',
    calories: 'Kalori',
    productCode: 'Ürün Kodu',
    // Product table
    searchProduct: 'Ürün ara...',
    costPriceCol: 'Alış Fiyatı',
    sellPriceCol: 'Satış Fiyatı',
    stockCol: 'Stok',
    minOrderCol: 'Min Sipariş',
    noProducts: 'Henüz ürün eklenmemiş',
    minIncLine: 'Min: {min}, Kat: {inc} {unit}',
    // Discount dialog
    discountRules: 'İndirim Kuralları',
    discountRulesFor: 'İndirim Kuralları - {name}',
    discountRulesDesc: 'Miktar bazlı indirim kurallarını yönetin',
    noDiscountRules: 'Henüz indirim kuralı yok',
    newDiscountRule: 'Yeni Kural Ekle',
    minQuantity: 'Min. Miktar',
    discountType: 'Tür',
    percentageOption: 'Yüzde (%)',
    fixedOption: 'Sabit (₺)',
    discountValue: 'Değer',
    addRule: 'Kural Ekle',
    ruleAdded: 'İndirim kuralı eklendi',
    ruleAddFailed: 'İndirim eklenemedi',
    ruleDeleted: 'İndirim kuralı silindi',
    ruleDeleteFailed: 'Silme başarısız',
    discountRowPercent: '{qty}+ adet → %{value} indirim',
    discountRowFixed: '{qty}+ adet → {amount} indirim',
  },

  // Unit Management
  units: {
    title: 'Birim Yönetimi',
    subtitle: 'Depo ürünleri için birim dönüşüm tanımlarını yönetin',
    loading: 'Birim tanımları yükleniyor...',
    addDefinition: 'Yeni Tanım Ekle',
    infoText: 'Burada depodaki ürünlerin özel birim dönüşümlerini tanımlayabilirsiniz. Örneğin: 24 Adet Cola = 1 Koli gibi tanımlar yaparak stok miktarlarının ne anlama geldiğini belirleyebilirsiniz.',
    customConversions: 'özel birim dönüşümlerini',
    standardNote: 'Standart dönüşümler otomatik hesaplanır:',
    noRedefinition: 'Bu dönüşümleri tekrar tanımlamanıza gerek yoktur.',
    definitions: 'Birim Tanımları',
    product: 'Ürün',
    baseQuantity: 'Temel Miktar',
    conversion: 'Dönüşüm',
    action: 'İşlem',
    noDefinitions: 'Henüz birim tanımı eklenmemiş',
    editDefinition: 'Birim Tanımı Düzenle',
    newDefinition: 'Yeni Birim Tanımı',
    dialogDesc: 'Ürün için birim dönüşüm bilgisini girin',
    productRequired: 'Ürün *',
    selectProduct: 'Ürün seçin',
    baseQtyLabel: 'Temel Miktar',
    baseUnit: 'Temel Birim',
    conversionQty: 'Dönüşüm Miktarı',
    unitLabel: 'Birim',
    standardWarning: 'Bu standart bir dönüşümdür.',
    standardWarningDetail: 'dönüşümü sistem tarafından otomatik hesaplanır. Burada sadece özel dönüşümleri (Koli, Kasa, Paket vb.) tanımlamanız yeterlidir.',
    fillAllFields: 'Lütfen tüm alanları doldurun',
    definitionUpdated: 'Birim tanımı güncellendi',
    duplicateExists: 'Bu ürün için birim çifti zaten tanımlı',
    definitionAdded: 'Birim tanımı eklendi',
    existingDefinition: 'Bu ürün için zaten bir birim tanımı mevcut',
    deleteConfirm: 'Bu birim tanımını silmek istediğinize emin misiniz?',
    definitionDeleted: 'Birim tanımı silindi',
    // Unit labels
    piece: 'Adet',
    kilogram: 'Kilogram (kg)',
    gram: 'Gram (g)',
    liter: 'Litre (L)',
    milliliter: 'Mililitre (ml)',
    box: 'Koli',
    crate: 'Kasa',
    sack: 'Çuval',
    canister: 'Bidon',
    bucket: 'Kova',
    pack: 'Paket',
    bag: 'Poşet',
  },
  // B2B Catalog
  b2b: {
    title: 'Tedarik Kataloğu',
    authRequired: 'Yetkilendirme Gerekli',
    authRequiredDesc: 'Bu sayfayı görüntülemek için giriş yapmanız ve bir markaya atanmış olmanız gerekmektedir.',
    searchProduct: 'Ürün ara...',
    allCategories: 'Tüm Kategoriler',
    errorTitle: 'Hata',
    noBranch: 'Şube bilgisi bulunamadı. Lütfen giriş yapın.',
    emptyCart: 'Sepetiniz boş.',
    successTitle: 'Başarılı',
    orderSent: 'Siparişiniz başarıyla gönderildi.',
    orderFailed: 'Sipariş gönderilemedi. Lütfen tekrar deneyin.',
  },
  // Dispatcher
  dispatcher: {
    title: 'Sevkiyat Paneli',
    subtitle: 'Ödemesi tamamlanan siparişlerin sevkiyat yönetimi',
    loading: 'Sevkiyatlar yükleniyor...',
    queued: 'Kuyrukta',
    inTransit: 'Yolda',
    delivered: 'Teslim Edildi',
    orderUnit: 'sipariş',
    deliveryUnit: 'teslimat',
    todayUnit: 'bugün',
    awaitingShipment: 'Sevkiyat Bekleyen',
    unknownBranch: 'Bilinmeyen Şube',
    invoice: 'Fatura',
    addToQueue: 'Kuyruğa Ekle',
    noAwaitingOrders: 'Sevkiyat bekleyen sipariş bulunmuyor',
    shipmentQueue: 'Sevkiyat Kuyruğu',
    emptyQueue: 'Sevkiyat kuyruğu boş',
    estimated: 'Tahmini',
    unknown: 'Bilinmeyen',
    inTransitShipments: 'Yoldaki Sevkiyatlar',
    inTransitDesc: 'Şube teslim almasını bekliyor — bu sevkiyatlar POS üzerinden kapatılır.',
    departure: 'Çıkış',
    loading2: 'Yükleniyor',
    shipped: 'Yolda',
    statusQueued: 'Kuyrukta',
    statusLoading: 'Yükleniyor',
    statusShipped: 'Yolda',
    statusDelivered: 'Teslim Edildi',
  },
  // Shipment History
  shipmentHistory: {
    title: 'Sevkiyat Geçmişi',
    subtitle: 'Teslim edilmiş sevkiyatların listesi',
    loading: 'Sevkiyat geçmişi yükleniyor...',
    totalDeliveries: 'Toplam Teslimat',
    totalAmount: 'Toplam Tutar',
    deliveredShipments: 'Teslim Edilen Sevkiyatlar',
    noDeliveries: 'Henüz teslim edilmiş sevkiyat bulunmuyor',
    delivered: 'Teslim Edildi',
    invoice: 'Fatura',
  },
  // Order History
  orderHistory: {
    title: 'Sipariş Takibi',
    subtitle: 'Tedarik siparişlerinizi görüntüleyin',
    loading: 'Yetki kontrol ediliyor...',
    accessDenied: 'Erişim Engellendi',
    accessDeniedDesc: 'Bu sayfayı görüntülemek için gerekli izne sahip değilsiniz.',
    allStatuses: 'Tüm Durumlar',
    pending: 'Beklemede',
    approved: 'Onaylandı',
    preparing: 'Hazırlanıyor',
    shipped: 'Kargoda',
    delivered: 'Teslim Edildi',
    cancelled: 'İptal Edildi',
    orders: 'Siparişler',
    noOrders: 'Henüz sipariş bulunmamaktadır.',
    orderNo: 'Sipariş No',
    date: 'Tarih',
    productCount: 'Ürün Sayısı',
    total: 'Toplam',
    status: 'Durum',
    action: 'İşlem',
    items: 'kalem',
    detail: 'Detay',
  },
  // Mystery Shopper
  mystery: {
    title: 'Gizli Müşteri Paneli',
    subtitle: 'Şube değerlendirme ve puanlama formu',
    reviewTab: 'Değerlendirme',
    settingsTab: 'Ayarlar',
    newReview: 'Yeni Değerlendirme',
    branch: 'Şube',
    selectBranch: 'Şube seçin',
    visitDate: 'Ziyaret Tarihi',
    detailedComments: 'Detaylı Yorumlar',
    commentsPlaceholder: 'Deneyiminizi detaylı olarak açıklayın...',
    saving: 'Kaydediliyor...',
    saveReview: 'Değerlendirmeyi Kaydet',
    previousReviews: 'Önceki Değerlendirmeler',
    unknownBranch: 'Bilinmeyen Şube',
    noReviews: 'Henüz değerlendirme bulunmuyor',
    cleanliness: 'Temizlik',
    service: 'Hizmet',
    food: 'Yemek',
    waitTime: 'Bekleme',
    minutes: 'dk',
    evaluator: 'Değerlendiren',
  },
  // Accountant Dashboard
  accountant: {
    title: 'Muhasebe Paneli',
    subtitle: 'Onaylı siparişler için fatura kesimi ve ödeme takibi',
    loading: 'Faturalar yükleniyor...',
    pending: 'Bekleyen',
    returns: 'İadeler',
    paid: 'Ödendi',
    totalAmount: 'Toplam',
    invoice: 'fatura',
    completedReturn: 'tamamlanan iade',
    invoiceAmount: 'fatura tutarı',
    ordersAwaitingInvoice: 'Fatura Bekleyen Siparişler',
    invoices: 'Faturalar',
    unknownBranch: 'Bilinmeyen Şube',
    createInvoice: 'Fatura Oluştur',
    createInvoiceBtn: 'Fatura Kes',
    invoiceNo: 'Fatura No',
    customerName: 'Müşteri Adı',
    taxNo: 'Vergi No',
    amount: 'Tutar',
    notesOptional: 'Notlar (Opsiyonel)',
    creating: 'Oluşturuluyor...',
    noOrdersAwaiting: 'Fatura bekleyen sipariş bulunmuyor',
    noInvoices: 'Henüz fatura bulunmuyor',
    sale: 'Satış',
    returnLabel: 'İade',
    paidLabel: 'Ödendi',
    unpaid: 'Ödenmedi',
    markPaid: 'Ödendi',
    view: 'Görüntüle',
    customer: 'Müşteri',
    type: 'Tip',
    status: 'Durum',
    // Invoice Detail Sheet
    invoiceDetail: 'Fatura Detayı',
    invoiceInfo: 'Fatura Bilgileri',
    statusLabel: 'Durum',
    issuedDate: 'Kesim Tarihi',
    paymentDate: 'Ödeme Tarihi',
    notes: 'Notlar',
    orderInfo: 'Sipariş Bilgileri',
    orderId: 'Sipariş ID',
    branch: 'Şube',
    orderAmount: 'Sipariş Tutarı',
    orderDate: 'Sipariş Tarihi',
    orderItems: 'Sipariş Kalemleri',
    piece: 'adet',
    paymentInfo: 'Ödeme Bilgileri',
    paymentMethod: 'Ödeme Yöntemi',
    paymentAmount: 'Ödeme Tutarı',
    bank: 'Banka',
    checkNo: 'Çek No',
    maturityDate: 'Vade Tarihi',
    referenceNo: 'Referans No',
    note: 'Not',
    paymentDetailNotFound: 'Ödeme detayı bulunamadı',
    // Invoice statuses
    statusPending: 'Bekliyor',
    statusIssued: 'Kesildi',
    statusPaid: 'Ödendi',
    statusCancelled: 'İptal',
    // Payment Confirmation Dialog
    paymentConfirmation: 'Ödeme Onayı',
    invoiceLabel: 'Fatura',
    paymentMethodLabel: 'Ödeme Yöntemi',
    cash: 'Nakit',
    card: 'Kredi Kartı',
    transfer: 'Havale/EFT',
    check: 'Çek',
    bankName: 'Banka Adı',
    bankNamePlaceholder: 'Banka adını girin',
    checkNumber: 'Çek No',
    checkNumberPlaceholder: 'Çek numarasını girin',
    maturityPeriod: 'Vade Süresi',
    month1: '1 Ay',
    month3: '3 Ay',
    month6: '6 Ay',
    year1: '1 Yıl',
    custom: 'Özel',
    customMaturityDate: 'Özel Vade Tarihi',
    selectDate: 'Tarih seçin',
    referenceNoOptional: 'Referans No (Opsiyonel)',
    referencePlaceholder: 'Referans numarası',
    noteOptional: 'Not (Opsiyonel)',
    notePlaceholder: 'Ödeme notu',
    processing: 'İşleniyor...',
    confirmPayment: 'Ödemeyi Onayla',
  },
  // Activity Logs
  activityLogs: {
    title: 'Aktivite Logları',
    subtitle: 'Sistemdeki tüm işlemleri takip edin',
    filters: 'Filtreler',
    startDate: 'Başlangıç',
    endDate: 'Bitiş',
    table: 'Tablo',
    all: 'Tümü',
    action: 'İşlem',
    user: 'Kullanıcı',
    searchEmail: 'E-posta ara...',
    results: 'Sonuçlar',
    date: 'Tarih',
    summary: 'Özet',
    loading: 'Yükleniyor...',
    noRecords: 'Kayıt bulunamadı',
    page: 'Sayfa',
    operationDetails: 'İşlem Detayları',
    insert: 'Ekleme',
    update: 'Düzenleme',
    delete: 'Silme',
    // Table labels
    tableMenuProducts: 'Menü Ürünleri',
    tableMenuCategories: 'Menü Kategorileri',
    tableBranches: 'Şubeler',
    tableCampaigns: 'Kampanyalar',
    
    tablePaymentMethods: 'Ödeme Yöntemleri',
    tableDiscountDefs: 'İndirim Tanımları',
    tableUserRoles: 'Kullanıcı Rolleri',
    tableVariationDefs: 'Varyasyon Tanımları',
    tablePriceRules: 'Fiyat Kuralları',
    tablePriceGroups: 'Fiyat Grupları',
    tableB2BOrders: 'B2B Siparişler',
    tableB2BProducts: 'B2B Ürünler',
    summaryTab: 'Özet',
    rawDataTab: 'Ham Veri',
    recordCreated: 'Yeni kayıt eklendi',
    recordUpdated: 'Kayıt güncellendi',
    recordDeleted: 'Kayıt silindi',
    fieldChanged: 'değiştirildi',
    changedFields: 'Değişen Alanlar',
    noChanges: 'Değişiklik tespit edilemedi',
    fieldNames: {
      name: 'Ad',
      product_name: 'Ürün Adı',
      branch_name: 'Şube Adı',
      group_name: 'Grup Adı',
      rule_name: 'Kural Adı',
      status: 'Durum',
      email: 'E-posta',
      title: 'Başlık',
      unit_price: 'Birim Fiyat',
      quantity: 'Miktar',
      total_amount: 'Toplam Tutar',
      payment_status: 'Ödeme Durumu',
      price: 'Fiyat',
      description: 'Açıklama',
      is_active: 'Aktif',
      role: 'Rol',
      category_name: 'Kategori Adı',
      product_code: 'Ürün Kodu',
      discount_type: 'İndirim Türü',
      discount_value: 'İndirim Değeri',
      min_quantity: 'Min. Miktar',
      max_quantity: 'Maks. Miktar',
      order_status: 'Sipariş Durumu',
    },
  },
  // Branch Dashboard
  branchDashboard: {
    title: 'Şube Paneli',
    subtitle: 'Restoranınızın tedarik ve sipariş süreçlerini buradan yönetin',
    loading: 'Şube paneli yükleniyor...',
    checkingPermission: 'Yetki kontrol ediliyor...',
    accessDenied: 'Erişim Engellendi',
    accessDeniedMessage: 'Bu sayfaya erişim yetkiniz bulunmamaktadır.',
    pendingOrders: 'Bekleyen',
    pendingSubtitle: 'Onay bekliyor',
    approvedOrders: 'Onaylandı',
    approvedSubtitle: 'Hazırlanıyor',
    shippedOrders: 'Kargoda',
    shippedSubtitle: 'Yolda',
    deliveredOrders: 'Tamamlandı',
    deliveredSubtitle: 'Teslim edildi',
    quickAccess: 'Hızlı Erişim',
    materialOrder: 'Malzeme Siparişi',
    materialOrderDesc: 'Tedarik ürün kataloğu',
    myOrders: 'Siparişlerim',
    myOrdersDesc: 'Sipariş takibi',
    supportTicket: 'Destek Talebi',
    supportTicketDesc: 'Sorun bildir',
    ticketSuccess: 'Başarılı',
    ticketSuccessDesc: 'Destek talebi başarıyla oluşturuldu.',
    ticketError: 'Hata',
    ticketErrorDesc: 'Destek talebi oluşturulurken bir hata oluştu.',
  },
  // Current Accounts
  currentAccounts: {
    // Common
    selectBranch: 'Şube seçin...',
    loading: 'Yükleniyor...',
    // Report Card
    reportCardTitle: 'Cari Karne',
    reportCardSubtitle: 'Şubenin genel cari durumunu, borç/alacak bakiyesini ve risk limitini özetler.',
    edit: 'Düzenle',
    noAccountFound: 'Bu şube için cari hesap kartı bulunamadı.',
    createAccount: 'Cari Hesap Oluştur',
    accountUserName: 'Cari Kullanıcı Adı',
    accountCode: 'Cari Kodu',
    riskLimit: 'Risk Limiti',
    extraCollectionAmount: 'Ekstra Tahsilat Tutarı',
    branchBalance: 'Şube Bakiyesi',
    hasDebt: 'Borç Var',
    hasCredit: 'Alacak Var',
    balanced: 'Dengede',
    editAccount: 'Cari Hesap Düzenle',
    createAccountTitle: 'Cari Hesap Oluştur',
    editAccountDesc: 'Mevcut cari hesap bilgilerini güncelleyin.',
    createAccountDesc: 'Seçili şube için yeni bir cari hesap kartı oluşturun.',
    accountCodePlaceholder: 'Örn: 120.10.10.571',
    riskLimitLabel: 'Risk Limiti (₺)',
    extraCollectionLabel: 'Ekstra Tahsilat Tutarı (₺)',
    cancel: 'İptal',
    saving: 'Kaydediliyor...',
    save: 'Kaydet',
    branch: 'Şube',
    // All Accounts Overview
    totalBalance: 'Toplam Bakiye',
    debtorBranches: 'Borçlu Şube',
    debtToHQ: 'Merkeze borcu olan',
    creditorBranches: 'Alacaklı Şube',
    creditFromHQ: 'Merkeze alacağı olan',
    allBranchBalances: 'Tüm Şube Bakiyeleri',
    noAccountsYet: 'Henüz cari hesap kaydı bulunmuyor.',
    status: 'Durum',
    balance: 'Bakiye',
    // Statement
    statementTitle: 'Cari Ekstre',
    statementSubtitle: 'Şubenin borç/alacak hareketlerini kronolojik sırada listeler.',
    transactions: 'Hesap Hareketleri',
    selectBranchPrompt: 'Lütfen bir şube seçin',
    noTransactions: 'Hareket bulunamadı',
    date: 'Tarih',
    documentType: 'Evrak Türü',
    documentNo: 'Evrak No',
    description: 'Açıklama',
    debit: 'Borç',
    credit: 'Alacak',
    // Invoices
    invoicesTitle: 'Faturalar',
    invoicesSubtitle: 'Şubeye kesilen faturaları ve detaylarını görüntüler.',
    invoiceList: 'Fatura Listesi',
    noInvoices: 'Fatura bulunamadı',
    invoiceNo: 'Fatura No',
    tax: 'KDV',
    discount: 'İndirim',
    total: 'Toplam',
    invoiceDetail: 'Fatura Detayı',
    customer: 'Müşteri',
    invoiceType: 'Fatura',
    statusPending: 'Beklemede',
    statusIssued: 'Kesildi',
    statusPaid: 'Ödendi',
    statusCancelled: 'İptal',
    productName: 'Ürün Adı',
    quantity: 'Miktar',
    unitPrice: 'Birim Fiyat',
    // Orders
    ordersTitle: 'Siparişler',
    ordersSubtitle: 'Şubenin merkeze verdiği siparişleri ve detaylarını listeler.',
    pastOrdersTitle: 'Geçmiş Siparişler',
    pastOrdersSubtitle: 'Önceki aylara ait sipariş geçmişini görüntüleyin.',
    orderList: 'Sipariş Listesi',
    noOrders: 'Sipariş bulunamadı',
    orderNo: 'Sipariş No',
    showAll: 'Tümünü Göster',
    orders: 'sipariş',
    statusApproved: 'Onaylandı',
    statusPreparing: 'Hazırlanıyor',
    statusShipped: 'Kargoda',
    statusDelivered: 'Teslim',
    // Payments
    paymentsTitle: 'Ödemeler',
    paymentsSubtitle: 'Şubenin merkeze yaptığı ödemelerin geçmişini görüntüleyin.',
    paymentHistory: 'Ödeme Geçmişi',
    noPayments: 'Ödeme bulunamadı',
    pendingPayments: 'Onay Bekleyen Ödeme Bildirimleri',
    confirmPayment: 'Onayla',
    rejectPayment: 'Reddet',
    paymentConfirmedToast: 'Ödeme onaylandı ve cari hesaba işlendi',
    paymentRejectedToast: 'Ödeme bildirimi reddedildi',
    paymentActionError: 'Ödeme işlemi tamamlanamadı',
    paymentStatus: 'Durum',
    paymentStatusPending: 'Onay bekliyor',
    paymentStatusDigital: 'Evrak bekliyor',
    paymentStatusConfirmed: 'Onaylandı',
    paymentStatusRejected: 'Reddedildi',
    amount: 'Tutar',
    paymentMethod: 'Ödeme Yöntemi',
    referenceNo: 'Referans No',
    notes: 'Notlar',
    // Cart
    cartTitle: 'Sepet',
    cartSubtitle: 'B2B katalogdan seçilen ürünlerin sipariş öncesi toplandığı alandır.',
    cartMessage: 'Sipariş sepetiniz B2B Katalog sayfasında yönetilmektedir.',
    goToOrders: 'Sipariş Sayfasına Git',
    // Return Requests
    returnTitle: 'İade Yönetimi',
    returnSubtitle: 'Şubelerden gelen iade taleplerini inceleyin, onaylayın veya reddedin.',
    returnRequests: 'İade Talepleri',
    noReturnRequests: 'İade talebi bulunamadı',
    requestNo: 'Talep No',
    itemCount: 'Kalem',
    action: 'İşlem',
    approve: 'Onayla',
    reject: 'Reddet',
    complete: 'Tamamla',
    returnDetail: 'İade Detayı',
    returnItems: 'İade Kalemleri',
    product: 'Ürün',
    reason: 'Neden',
    noItemInfo: 'Kalem bilgisi yok',
    totalAmount: 'Toplam Tutar',
    statusWaitingApproval: 'Onay Bekliyor',
    statusCompleted: 'Tamamlandı',
    statusRejected: 'Reddedildi',
    statusInvoiceUploaded: 'Fatura Yüklendi',
  },
  notifications: {
    title: 'Bildirimler',
    markAllRead: 'Tümünü Okundu İşaretle',
    empty: 'Henüz bildirim yok',
    viewAll: 'Tüm Bildirimleri Gör',
    dismiss: 'Bildirimi Kaldır',
    clearAllRead: 'Okunanları Temizle',
    allNotifications: 'Tüm Bildirimler',
    listed: 'bildirim listeleniyor',
    unreadCount: 'okunmamış',
    noNotifications: 'Henüz bildirim yok',
    filterAll: 'Tümü',
    filterUnread: 'Okunmamış',
    filterRead: 'Okunmuş',
    dateAll: 'Tüm Zamanlar',
    dateToday: 'Bugün',
    dateWeek: 'Son 7 Gün',
    dateMonth: 'Bu Ay',
    dismissed: 'Kaldırıldı',
    events: {
      newSupportRequest: { title: 'Yeni Destek Talebi', message: '#{ref} - {subject}' },
      supportRequestUpdated: { title: 'Destek Talebi Güncellendi', message: '#{ref} durumu: {status}' },
      newShipment: { title: '📦 Yeni Sevkiyat', message: 'Sipariş #{ref} sevkiyat kuyruğuna eklendi.' },
      paymentReceived: { title: '💰 Ödeme Kaydedildi', message: '{amount} ₺ ödeme kaydedildi ({method})' },
      newInvoice: { title: '📄 Yeni Fatura', message: 'Fatura #{number} kesildi — {amount} ₺' },
      returnApproved: { title: '✅ İade Onaylandı', message: '{amount} ₺ tutarındaki iade talebiniz onaylandı.' },
      returnRejected: { title: '❌ İade Reddedildi', message: 'İade talebiniz reddedildi.' },
      stockShortage: { title: '⚠️ Stok Aşımı Uyarısı', message: '{product} için istenen {requested} adet, mevcut stok {available}. Eksik: {shortage} adet.' },
      orderApproved: { title: '✅ Sipariş Onaylandı', message: '#{ref} numaralı siparişiniz onaylandı.' },
      orderCancelled: { title: '❌ Sipariş İptal Edildi', message: '#{ref} numaralı siparişiniz iptal edildi.' },
      newMysteryReview: { title: '🔍 Yeni Gizli Müşteri Değerlendirmesi', message: 'Genel puan: {score}/100' },
      lowMysteryScore: { title: '⚠️ Düşük Gizli Müşteri Puanı', message: 'Şube değerlendirmesi {score}/100 puan aldı.' },
    },
  },
  notificationPreferences: {
    title: 'Bildirim Tercihleri',
    description: 'Hangi bildirim türlerini almak istediğinizi seçin.',
    save: 'Kaydet',
    cancel: 'İptal',
    saved: 'Bildirim tercihleri kaydedildi',
    saveError: 'Tercihler kaydedilemedi',
    groups: {
      ordersSupply: 'Sipariş & Tedarik',
      finance: 'Finans',
      operations: 'Operasyon',
      supportSystem: 'Destek & Sistem',
    },
    types: {
      new_order: 'Yeni Sipariş',
      order_status: 'Sipariş Durumu',
      invoice: 'Fatura',
      payment: 'Ödeme',
      return_request: 'İade Talebi',
      shipment: 'Sevkiyat',
      ticket: 'Destek Talebi',
      campaign: 'Kampanya',
      price_update: 'Fiyat Güncelleme',
      mystery_review: 'Mystery Shopper',
      stock_warning: 'Stok Uyarısı',
      system_alerts: 'Sistem Bildirimleri',
      new_application: 'Yeni Başvuru',
    },
  },
  onboarding: {
    guide: 'Rehber',
    skip: 'Atla',
    prev: 'Geri',
    next: 'İleri',
    finish: 'Tamamla',
    lookAtHighlight: 'Vurgulanan alana bakın ↑',
    steps: {
      dashboard: {
        title: 'Kontrol Paneli',
        description: 'Satış özetleri, dönemsel karşılaştırmalar ve hızlı erişim burada. Anlık performansınızı takip edin.',
      },
      brandsBranches: {
        title: 'Marka & Şube Yönetimi',
        description: 'Franchise markalarınızı ve şubelerinizi buradan ekleyip yönetin.',
      },
      menu: {
        title: 'Menü & Depo Yönetimi',
        description: 'Ürünler, kategoriler, stok ve tedarik süreçlerini merkezi olarak düzenleyin.',
      },
      orders: {
        title: 'Sipariş Takibi',
        description: 'Şubelerden gelen siparişleri ve online platform siparişlerini buradan takip edin.',
      },
      reports: {
        title: 'Raporlar & Analiz',
        description: 'Satış raporları, performans kıyaslamaları ve online platform analizleri.',
      },
      pricing: {
        title: 'Fiyat Yönetimi',
        description: 'Merkezi fiyatlandırma grupları oluşturun ve şubelere atayın.',
      },
      users: {
        title: 'Kullanıcı & Rol Yönetimi',
        description: 'Ekip üyelerini ekleyin, roller ve sayfa erişim yetkilerini yönetin.',
      },
    },
  },
  businessAnalytics: {
    title: 'İş Analitiği',
    subtitle: 'Sepet, menü, kanal ve büyüme analizleri',
    loading: 'Analitik verileri yükleniyor...',
    noData: 'Bu dönem için veri bulunamadı',
    allBranches: 'Tüm Şubeler',
    unnamed: 'İsimsiz Şube',
    allTime: 'Tüm Zamanlar',
    today: 'Bugün',
    thisWeek: 'Bu Hafta',
    thisMonth: 'Bu Ay',
    thisYear: 'Bu Yıl',
    customRange: 'Özel Aralık',
    basketTab: 'Sepet Analizi',
    menuEngineeringTab: 'Menü Matrisi',
    channelsTab: 'Kanal Performansı',
    growthTab: 'Büyüme',
    avgOrderValue: 'Ort. Sipariş Değeri',
    avgItemsPerOrder: 'Ort. Ürün/Sipariş',
    totalOrders: 'Toplam Sipariş',
    aovTrend: 'AOV Trendi',
    topPairs: 'En Çok Birlikte Sipariş Edilen Ürünler',
    topPairsDesc: 'Aynı siparişte en sık birlikte yer alan ürün çiftleri',
    product1: 'Ürün 1',
    product2: 'Ürün 2',
    pairCount: 'Birlikte Sayısı',
    stars: 'Yıldızlar',
    puzzles: 'Bulmacalar',
    workhorses: 'İş Atları',
    dogs: 'Köpekler',
    menuMatrix: 'Menü Mühendisliği Matrisi',
    menuMatrixDesc: 'X: Satış adedi (popülerlik), Y: Kar marjı',
    quantity: 'Adet',
    margin: 'Marj',
    revenue: 'Ciro',
    productDetails: 'Ürün Detayları',
    productName: 'Ürün Adı',
    category: 'Kategori',
    quadrant: 'Kadran',
    totalRevenue: 'Toplam Ciro',
    channelComparison: 'Kanal Karşılaştırması',
    channelDetails: 'Kanal Detayları',
    channel: 'Kanal',
    orderCount: 'Sipariş Sayısı',
    weekOverWeek: 'Hafta / Hafta',
    monthOverMonth: 'Ay / Ay',
    salesGrowth: 'Satış Büyümesi',
    orderGrowth: 'Sipariş Büyümesi',
    currentPeriod: 'Bu Dönem',
    previousPeriod: 'Önceki Dönem',
    growth: 'Büyüme',
    branchGrowthRanking: 'Şube Büyüme Sıralaması',
    branchGrowthRankingDesc: 'Aylık büyüme oranına göre şube sıralaması',
    branchName: 'Şube',
    starsDesc: 'Yüksek satış + yüksek kar marjı',
    puzzlesDesc: 'Düşük satış + yüksek kar marjı',
    workhorsesDesc: 'Yüksek satış + düşük kar marjı',
    dogsDesc: 'Düşük satış + düşük kar marjı',
    starsAction: 'Öne çıkar, menüde vurgula',
    puzzlesAction: 'Satışı artır, kampanya yap',
    workhorsesAction: 'Fiyat/maliyet optimize et',
    dogsAction: 'Menüden kaldırmayı değerlendir',
    promoteThese: 'Öne Çıkar',
    boostSales: 'Satışı Artır',
    considerRemoving: 'Kaldırmayı Değerlendir',
    allCategories: 'Tüm Kategoriler',
    clickToFilter: 'Filtrelemek için tıkla',
    products: 'ürün',
    recommendation: 'Öneri',
    avgPrice: 'Ort. Fiyat',
    popularityAxis: 'Popülerlik (Satış Adedi)',
    profitAxis: 'Kar Marjı (%)',
    avgPopularity: 'Ort. Popülerlik',
    avgMargin: 'Ort. Marj',
    aovChange: 'Ort. Sipariş Değeri Değişimi',
    fastestGrowing: 'En Hızlı Büyüyen',
    declining: 'Gerileyen Şubeler',
    branchGrowthChart: 'Şube Satış Karşılaştırması',
    branchGrowthChartDesc: 'Bu dönem vs. önceki dönem şube bazlı satış',
    difference: 'Fark',
    salesShare: 'Pay',
    overallAOV: 'Genel AOV',
    activeChannels: 'Aktif Kanal',
    weeklyChannelTrend: 'Haftalık Kanal Trendi',
    weeklyChannelTrendDesc: 'Kanal bazlı haftalık ciro değişimi',
    highestAOV: 'En Yüksek AOV',
    highestAOVDesc: 'Sipariş başına en yüksek gelir getiren kanal',
    mostOrders: 'En Çok Sipariş',
    mostOrdersDesc: 'En yoğun sipariş trafiğine sahip kanal',
    aovTrendDesc: 'Günlük veya haftalık ortalama sipariş değeri değişimi',
    daily: 'Günlük',
    weekly: 'Haftalık',
    itemsPerOrderTrend: 'Sipariş Başına Ürün Sayısı',
    itemsPerOrderTrendDesc: 'Günlük ortalama ürün sayısı trendi',
    orderVolumeTrend: 'Sipariş Hacmi',
    orderVolumeTrendDesc: 'Günlük sipariş sayısı trendi',
    peakDay: 'En Yüksek Satış Günü',
    bestAOVDay: 'En Yüksek AOV Günü',
    largestBasketDay: 'En Büyük Sepet Günü',
  },
  finance: {
    title: 'Gelir/Gider Yönetimi',
    subtitle: 'Ana merkez gelir ve gider kalemlerini yönetin',
    totalIncome: 'Toplam Gelir',
    totalExpense: 'Toplam Gider',
    netProfit: 'Net Kar/Zarar',
    recurringExpense: 'Tekrarlayan Gider',
    addEntry: 'Kayıt Ekle',
    entryType: 'Tür',
    expense: 'Gider',
    income: 'Gelir',
    category: 'Kategori',
    selectCategory: 'Kategori seçin',
    customCategory: 'Özel kategori adı',
    amount: 'Tutar',
    date: 'Tarih',
    description: 'Açıklama',
    repeatMonthly: 'Her ay tekrarlansın',
    recurringDay: 'Ayın günü',
    cancel: 'İptal',
    save: 'Kaydet',
    saved: 'Kayıt başarıyla eklendi',
    deleted: 'Kayıt silindi',
    noEntries: 'Kayıt bulunamadı',
    allTypes: 'Tüm Türler',
    monthlySummary: 'Aylık Özet',
    entriesList: 'Gelir/Gider Listesi',
    recurringEntries: 'Tekrarlayan Kalemler',
    processRecurring: 'Oluştur',
    noRecurring: 'Tekrarlayan kayıt yok',
    everyMonthDay: 'Her ayın {day}. günü',
    financeTab: 'Gelir/Gider',
  },
  callcenter: {
    applications: 'Başvurular',
    applicationsCount: 'Başvurular ({count})',
    newApplication: 'Yeni Başvuru',
    searchPlaceholder: 'İsim, telefon veya email ile ara...',
    applicationType: 'Başvuru Tipi',
    allTypes: 'Tüm Tipler',
    typeDealer: 'Bayi',
    typeFranchise: 'Franchise',
    typeRental: 'Kiralık Yer',
    typeDelivery: 'Paket Taşıma',
    status: 'Durum',
    allStatuses: 'Tüm Durumlar',
    statusNew: 'Yeni',
    statusContacted: 'İletişime Geçildi',
    statusInProgress: 'İşlemde',
    statusApproved: 'Onaylandı',
    statusRejected: 'Reddedildi',
    typeDealerFull: 'Bayi Başvurusu',
    typeFranchiseFull: 'Franchise Başvurusu',
    typeRentalFull: 'Kiralık Yer Önerisi',
    typeDeliveryFull: 'Paket Taşıma Hizmeti',
    fullName: 'Ad Soyad',
    typeCol: 'Tip',
    proposedBranch: 'Önerilen Şube',
    contact: 'İletişim',
    location: 'Konum',
    dateCol: 'Tarih',
    actions: 'İşlem',
    notFound: 'Başvuru bulunamadı',
    more: 'Daha fazla',
    viewDetail: 'Detay Gör',
    markContacted: 'İletişime Geçildi',
    takeInProgress: 'İşleme Al',
    approveManual: 'Onayla (Manuel)',
    reject: 'Reddet',
    approve: 'Onayla',
    applicationDetail: 'Başvuru Detayı',
    personalInfo: 'Kişisel Bilgiler',
    businessInfo: 'İşletme Bilgileri',
    locationInfo: 'Konum',
    approvalInfo: 'Onay Bilgileri',
    phone: 'Telefon',
    email: 'E-posta',
    taxNumber: 'Vergi Numarası',
    proposedBranchName: 'Önerilen Şube Adı',
    notes: 'Notlar',
    city: 'Şehir',
    district: 'İlçe',
    address: 'Adres',
    createdBranch: 'Oluşturulan Şube',
    branchCode: 'Şube Kodu',
    totalApplications: 'Toplam Başvuru',
    conversionRate: 'Dönüşüm Oranı',
    avgProcessingDays: 'Ort. İşlem Süresi',
    daysUnit: '{count} gün',
    pending: 'Bekleyen',
    monthlyTrend: 'Aylık Başvuru Trendi',
    statusDistribution: 'Durum Dağılımı',
    statusDistributionAria: 'Başvuru Durum Dağılımı',
    cityDistribution: 'Şehir Bazlı Dağılım',
    typeDistribution: 'Başvuru Tipi Dağılımı',
    application: 'Başvuru',
    ratio: 'Oran',
    approvedCount: 'Onaylanan',
    rejectedCount: 'Reddedilen',
    approvedApplications: 'Onaylanan Başvurular',
    rejectedApplications: 'Reddedilen Başvurular',
    noApproved: 'Henüz onaylanan başvuru yok.',
    noRejected: 'Henüz reddedilen başvuru yok.',
    applicant: 'Başvuran',
    branch: 'Şube',
    duration: 'Süre',
    note: 'Not',
  },
  branchMonitor: {
    title: 'Bayi Aktivite İzleme',
    subtitle: 'Bayi POS hareketleri gerçek zamanlı olarak izlenir, şüpheli işlemler otomatik tespit edilir.',
    todayCritical: 'Bugün Kritik',
    todayHigh: 'Bugün Yüksek',
    todayMedium: 'Bugün Orta',
    todayLow: 'Bugün Düşük',
    anomaliesTab: 'Anomaliler ({count})',
    allLogsTab: 'Tüm Loglar',
    heatmapTab: 'Risk Haritası',
    branchFilter: 'Bayi',
    severityFilter: 'Önem',
    typeFilter: 'Tür',
    allBranches: 'Tüm bayiler',
    allSeverities: 'Tümü',
    allTypesOpt: 'Tüm türler',
    onlyUnread: 'Sadece okunmamış',
    unnamedBranch: 'İsimsiz',
    severityCritical: 'Kritik',
    severityHigh: 'Yüksek',
    severityMedium: 'Orta',
    severityLow: 'Düşük',
    topCancelStaff: 'En Çok İptal Yapan Personel',
    unknownStaff: 'Bilinmeyen',
    noAnomalies: 'Filtreye uyan anomali bulunamadı.',
  },
  mysterySettings: {
    evaluationMetrics: 'Değerlendirme Metrikleri',
    newMetric: 'Yeni Metrik',
    editMetric: 'Metrik Düzenle',
    addMetric: 'Yeni Metrik Ekle',
    metricName: 'Metrik Adı',
    metricNamePlaceholder: 'Ör: Temizlik',
    iconLabel: 'İkon',
    typeLabel: 'Tür',
    scoreType: 'Puan (0-100)',
    durationType: 'Süre (dk)',
    min: 'Min',
    max: 'Max',
    defaultValue: 'Varsayılan',
    scoreShort: 'Puan',
    durationShort: 'Süre',
    upAria: 'Yukarı',
    downAria: 'Aşağı',
    editAria: 'Düzenle',
    deleteAria: 'Sil',
    deleteTitle: 'Metrik Sil',
    deleteConfirm: '"{name}" metriğini silmek istediğinize emin misiniz?',
    noMetrics: 'Henüz metrik tanımlanmamış',
  },
  periodComparison: {
    prevDay: 'Önceki Gün (Aynı Saat)',
    prevWeek: 'Önceki Hafta',
    prevMonth: 'Önceki Ay',
    customPeriod: 'Seçili Dönem',
    prevPeriod: 'Önceki Dönem',
    prev: 'Önceki',
    next: 'Sonraki',
    noPrevData: 'Karşılaştırma için önceki dönem verisi bulunamadı',
    salesRevenue: 'Satış Geliri',
    transactions: 'İşlem',
    branch: 'Şube',
    avgBasket: 'Ort. Sepet',
    productPerBasket: 'Ürün/Sepet',
  },
  bottomNav: {
    panel: 'Panel',
    orders: 'Siparişler',
    reports: 'Raporlar',
    branches: 'Şubeler',
    performance: 'Performans',
  },
  branchRiskHeatmap: {
    title: 'Risk Haritası (Bayi × Saat)',
    noBranches: 'Şube bulunamadı.',
    cellTitle: '{branch} • {hour}:00 — {count} anomali',
    emptyBranch: '—',
  },
  applicationsMobile: {
    contactMissing: 'İletişim yok',
    locationMissing: 'Konum yok',
  },
  productAnalysis: {
    loading: 'Ürün verileri yükleniyor...',
    topSelling: 'En Çok Satan Ürünler (Top 50)',
    noSales: 'Bu dönemde satış verisi bulunamadı.',
    productName: 'Ürün Adı',
    totalQuantity: 'Toplam Adet',
    avgUnitPrice: 'Ort. Birim Fiyat',
    totalRevenue: 'Toplam Ciro',
    revenueShare: 'Ciro Oranı',
    branchLocalSuffix: 'şube ürünü',
    priceDiscrepancies: 'Fiyat Farklılıkları (Şubeler Arası)',
    noDiscrepancies: 'Şubeler arası fiyat farklılığı tespit edilmedi.',
    diff: 'Fark',
    hqBasePrice: 'Merkez Taban Fiyatı',
    dineIn: 'Masa',
    delivery: 'Paket',
    basePrice: 'Taban',
    countUnit: 'adet',
  },
  branchProducts: {
    loading: 'Şube ürünleri yükleniyor...',
    selectBranch: 'Şube Seçin',
    allBranches: 'Tüm Şubeler',
    productsLabel: '{count} Ürün',
    activeLabel: '{count} Aktif',
    branchesLabel: '{count} Şube',
    title: 'Şube Yerel Ürünleri',
    notFound: 'Şube yerel ürünü bulunamadı.',
    branch: 'Şube',
    productName: 'Ürün Adı',
    category: 'Kategori',
    price: 'Fiyat',
    status: 'Durum',
    created: 'Oluşturulma',
    active: 'Aktif',
    inactive: 'Pasif',
  },
  salesCharts: {
    dailyTrend: 'Günlük Satış Trendi',
    dailyTrendDesc: 'Seçilen tarih aralığındaki günlük satışlar',
    salesLabel: 'Satış',
    branchComparison: 'Şube Karşılaştırması',
    branchComparisonDesc: 'Şube bazlı satış performansı',
    dailyTrendAria: 'Günlük satış trendi grafiği',
    branchComparisonAria: 'Şubelere göre satış karşılaştırma grafiği',
  },
  rolePermissions: {
    title: 'Kullanıcı Rollerini Düzenle',
    roles: 'Roller',
    custom: 'Özel',
    deleteTitle: 'Rolü Sil',
    roleName: 'Rol Adı',
    roleNamePlaceholder: 'Örn: Bölge Müdürü',
    roleKey: 'Rol Anahtarı',
    roleKeyPlaceholder: 'bolge_muduru',
    create: 'Oluştur',
    cancel: 'İptal',
    newRole: 'Yeni Rol',
    pagePermissions: 'Sayfa İzinleri:',
    selectRolePrompt: 'Düzenlemek için sol taraftan bir rol seçin',
    accountant: 'Muhasebeci',
    dispatcher: 'Sevkiyatçı',
    mysteryShopper: 'Gizli Müşteri',
  },
  toasts: {
    common: {
      error: 'Hata: {message}',
      sessionNotFound: 'Oturum bulunamadı',
      operationFailed: 'İşlem başarısız',
    },
    callCenter: {
      agentCreated: 'Agent oluşturuldu',
      agentUpdated: 'Agent güncellendi',
      applicationCreated: 'Başvuru kaydedildi',
      applicationStatusUpdated: 'Başvuru durumu güncellendi',
      applicationApproved: 'Başvuru Onaylandı — Şube "{name}" oluşturuldu. Giriş bilgileri kullanıcının e-postasına gönderildi.',
      applicationRejected: 'Başvuru reddedildi ve kayıtlar temizlendi.',
      approveFailed: 'Onay işlemi başarısız',
      rejectFailed: 'Reddetme işlemi başarısız',
      categoryCreated: 'Kategori oluşturuldu',
      topicCreated: 'Konu oluşturuldu',
      ticketCreated: 'Destek talebi oluşturuldu',
      ticketUpdated: 'Destek talebi güncellendi',
      ticketAssigned: 'Talep atandı',
      statusUpdated: 'Durum güncellendi',
    },
    branchAnomalies: {
      markedRead: 'Anomali okundu olarak işaretlendi',
    },
    mystery: {
      metricAdded: 'Metrik eklendi',
      metricUpdated: 'Metrik güncellendi',
      metricDeleted: 'Metrik silindi',
      reviewSaved: 'Değerlendirme kaydedildi',
    },
    advancedProducts: {
      optionCreated: 'Opsiyon oluşturuldu',
      optionCreateFailed: 'Opsiyon oluşturulamadı',
      optionUpdated: 'Opsiyon güncellendi',
      optionUpdateFailed: 'Opsiyon güncellenemedi',
      optionDeleted: 'Opsiyon silindi',
      optionDeleteFailed: 'Opsiyon silinemedi',
      mappingCreated: 'Eşleştirme oluşturuldu',
      mappingCreateFailed: 'Eşleştirme oluşturulamadı',
      mappingUpdated: 'Eşleştirme güncellendi',
      mappingUpdateFailed: 'Eşleştirme güncellenemedi',
      mappingDeleted: 'Eşleştirme silindi',
      mappingDeleteFailed: 'Eşleştirme silinemedi',
      categoryCreated: 'Kategori oluşturuldu',
      categoryCreateFailed: 'Kategori oluşturulamadı',
      categoryUpdated: 'Kategori güncellendi',
      categoryUpdateFailed: 'Kategori güncellenemedi',
      categoryDeleted: 'Kategori silindi',
      categoryDeleteFailed: 'Kategori silinemedi',
      optionLinked: 'Opsiyon ürüne bağlandı',
      optionLinkFailed: 'Opsiyon bağlanamadı',
      optionUnlinked: 'Opsiyon bağlantısı silindi',
      optionUnlinkFailed: 'Bağlantı silinemedi',
      errorTitle: 'Hata',
    },
    rolePermissions: {
      roleCreated: 'Rol oluşturuldu',
      roleCreateFailed: 'Rol oluşturulamadı: {message}',
      roleDeleted: 'Rol silindi',
      roleDeleteFailed: 'Rol silinemedi: {message}',
      permissionsUpdated: 'Sayfa izinleri güncellendi',
      permissionsUpdateFailed: 'İzinler güncellenemedi: {message}',
    },
    brands: {
      createSuccess: 'Marka başarıyla oluşturuldu',
      createFail: 'Marka oluşturulamadı',
      updateSuccess: 'Marka başarıyla güncellendi',
      updateFail: 'Marka güncellenemedi',
      deleteSuccess: 'Marka başarıyla silindi',
      deleteFail: 'Marka silinemedi. Bu markaya bağlı şubeler olabilir.',
      userCreated: 'Marka sahibi kullanıcısı oluşturuldu',
      userCreateFailFallback: 'Kullanıcı oluşturulamadı',
      sessionMissing: 'Oturum bulunamadı',
      authRequired: 'Kullanıcı oturumu bulunamadı',
    },
    branches: {
      createSuccess: 'Şube başarıyla oluşturuldu',
      createFail: 'Şube oluşturulamadı',
      updateSuccess: 'Şube başarıyla güncellendi',
      updateFail: 'Şube güncellenemedi',
      deleteSuccess: 'Şube başarıyla silindi',
      deleteFail: 'Şube silinemedi. Bu şubeye bağlı siparişler veya kullanıcılar olabilir.',
      authRequired: 'Kullanıcı oturumu bulunamadı',
    },
    franchiseMenu: {
      productCreated: 'Ürün oluşturuldu',
      productUpdated: 'Ürün güncellendi',
      productDeleted: 'Ürün silindi',
      categoryCreated: 'Kategori oluşturuldu',
      categoryUpdated: 'Kategori güncellendi',
      categoryDeleted: 'Kategori silindi',
      variationUpdated: 'Varyasyon güncellendi',
    },
    recipes: {
      ingredientAdded: 'Malzeme eklendi',
      ingredientUpdated: 'Malzeme güncellendi',
      ingredientDeleted: 'Malzeme silindi',
      recipeCreated: 'Reçete oluşturuldu',
      recipeUpdated: 'Reçete güncellendi',
      recipeDeleted: 'Reçete silindi',
    },
    priceGroups: {
      groupCreated: 'Fiyat grubu oluşturuldu',
      groupUpdated: 'Fiyat grubu güncellendi',
      packageProductsSaved: 'Paket ürünleri kaydedildi',
      productRemovedFromPackage: 'Ürün paketten çıkarıldı',
      branchPriceGroupUpdated: 'Şube fiyat grubu güncellendi',
    },
    payments: {
      paymentSaved: 'Ödeme kaydedildi',
    },
    invoices: {
      invoiceCreated: 'Fatura oluşturuldu',
      invoiceUpdated: 'Fatura güncellendi',
    },
    returns: {
      returnUpdated: 'İade talebi güncellendi',
      returnCompleted: 'İade tamamlandı ve cariye yansıtıldı',
      paymentStatusUpdated: 'İade ödeme durumu güncellendi',
    },
    userManagement: {
      roleDeleted: 'Rol başarıyla silindi',
      roleDeleteFailed: 'Rol silme başarısız oldu',
      userCreated: 'Kullanıcı başarıyla oluşturuldu',
      userCreateFailFallback: 'Kullanıcı oluşturulamadı',
      userUpdateFailFallback: 'Kullanıcı güncellenemedi',
      sessionMissing: 'Oturum bulunamadı',
    },
    shipmentQueue: {
      queued: 'Sevkiyat kuyruğuna eklendi',
      statusUpdated: 'Sevkiyat durumu güncellendi',
      orderStatusUpdateFailed: 'Sipariş durumu güncellenemedi: {message}',
    },
    performance: {
      targetAdded: 'Hedef başarıyla eklendi',
    },
    hqFinance: {
      recurringGenerated: '{count} tekrarlayan kayıt oluşturuldu',
    },
    branchPermissions: {
      updated: 'İzinler güncellendi',
    },
    crm: {
      questionCreated: 'Soru oluşturuldu',
      questionUpdated: 'Soru güncellendi',
    },
    costAnalysis: {
      costSaved: 'Maliyet kaydı başarıyla eklendi.',
    },
  },
  auth: {
    errors: {
      invalidCredentials: 'E-posta veya şifre hatalı',
      alreadyRegistered: 'Bu e-posta adresi zaten kayıtlı',
      passwordTooShort: 'Şifre en az 6 karakter olmalıdır',
      invalidEmail: 'Geçersiz e-posta adresi',
      alreadyExists: 'Bu e-posta adresi zaten kullanılıyor',
    },
    toast: {
      permissionErrorTitle: 'Yetki Hatası',
      permissionErrorDesc: 'Henüz size bir rol atanmamış. Yönetici ile iletişime geçin.',
      signInErrorTitle: 'Giriş Hatası',
      signUpErrorTitle: 'Kayıt Hatası',
      signUpFailFallback: 'Kayıt işlemi başarısız oldu',
      signUpSuccessTitle: 'Kayıt Başarılı',
      signUpSuccessDesc: 'Markanız oluşturuldu. Lütfen giriş yapın.',
      welcomeTitle: 'Hoş Geldiniz!',
      welcomeDesc: '{brand} markası oluşturuldu. Panele yönlendiriliyorsunuz.',
      genericErrorTitle: 'Hata',
      genericErrorDesc: 'Bir hata oluştu. Lütfen tekrar deneyin.',
    },
    form: {
      pageTitle: 'Giriş Yap',
      subtitle: 'İşletmenizi dünyanın her yerinden tek tıkla kontrol etmek için giriş yapın!',
      tabSignIn: 'Giriş Yap',
      tabSignUp: 'Üye Ol',
      emailLabel: 'E-POSTA ADRESİ',
      passwordLabel: 'ŞİFRE',
      signInButton: 'Giriş Yap',
      signUpButton: 'Üye Ol',
      secretLabel: 'KAYIT ANAHTARI',
      secretPlaceholder: 'Yönetici tarafından verilen anahtar',
      brandNameLabel: 'MARKA ADI',
      brandNamePlaceholder: 'Marka adınızı girin',
      phoneLabel: 'TELEFON NUMARASI',
      signupPasswordPlaceholder: 'En az 10 karakter (harf + rakam)',
      signUpFooter: 'Markanızı oluşturun ve yönetim panelinize hemen erişin.',
      imageAlt: 'Restoran iç mekan',
      themeToggleAria: 'Aydınlık mod',
    },
  },
  anomalyRules: {
    type: {
      hidden_order: 'Sipariş Silme',
      high_cancel: 'Yüksek İptal',
      off_hours_stock: 'Mesai Dışı Stok',
      excessive_discount: 'Aşırı İndirim',
      price_deviation: 'Fiyat Sapması',
      off_hours_login: 'Mesai Dışı Giriş',
    },
    severity: {
      low: 'Düşük',
      medium: 'Orta',
      high: 'Yüksek',
      critical: 'Kritik',
    },
    hits: {
      hiddenOrder: {
        title: 'Yüksek tutarlı sipariş silme (₺{amount})',
        description: '{staff} {table} {count} ürünlü siparişi sildi.',
      },
      highCancel: {
        title: 'Yüksek tutarlı iptal (₺{amount})',
        description: '{staff} ₺{amount} tutarındaki siparişi iptal etti.',
      },
      offHoursStock: {
        title: 'Mesai dışı stok hareketi ({hour}:00)',
        description: "{staff} gece {hour}:00'da {entity} üzerinde stok işlemi yaptı.",
      },
      excessiveDiscount: {
        title: 'Aşırı indirim uygulandı (%{rate})',
        description: '{staff} %{rate} indirim uyguladı.',
      },
      priceDeviation: {
        title: 'Fiyat değişikliği (%{pct})',
        description: '{entity} fiyatı ₺{oldPrice} → ₺{newPrice}',
      },
      offHoursLogin: {
        title: 'Mesai dışı giriş ({hour}:00)',
        description: "{staff} gece {hour}:00'da sisteme giriş yaptı.",
      },
    },
  },
  crmLabels: {
    status: {
      new: 'Yeni',
      contacted: 'İletişime Geçildi',
      in_progress: 'İşlemde',
      approved: 'Onaylandı',
      rejected: 'Reddedildi',
    },
    type: {
      dealer: 'Bayi',
      franchise: 'Franchise',
      rental_suggestion: 'Kiralık Yer',
      delivery_service: 'Paket Taşıma',
    },
    unspecifiedCity: 'Belirtilmemiş',
  },

  csvHeaders: {
    b2bProduct: {
      name: 'Ürün Adı',
      sku: 'SKU',
      price: 'Fiyat (TL)',
      step: 'Adım Miktarı',
      min: 'Minimum Sipariş',
      max: 'Maksimum Sipariş',
      unit: 'Birim',
      isActive: 'Aktif',
    },
    b2bOrder: {
      id: 'Sipariş No',
      branchName: 'Şube',
      status: 'Durum',
      totalAmount: 'Toplam (TL)',
      itemsCount: 'Ürün Sayısı',
      createdAt: 'Sipariş Tarihi',
    },
    salesReport: {
      branchName: 'Şube Adı',
      orderCount: 'Sipariş Sayısı',
      totalSales: 'Toplam Satış (TL)',
      cashTotal: 'Nakit (TL)',
      cardTotal: 'Kredi Kartı (TL)',
      avgOrder: 'Ort. Sipariş (TL)',
    },
  },
  orderStatus: {
    pending: 'Beklemede',
    approved: 'Onaylandı',
    preparing: 'Hazırlanıyor',
    shipped: 'Kargoya Verildi',
    delivered: 'Teslim Edildi',
    cancelled: 'İptal Edildi',
  },
  orderSummary: {
    title: 'Sipariş Özeti',
    empty: 'Sepetiniz boş',
    clear: 'Temizle',
    removeItemAria: '{name} ürününü kaldır',
    totalItems: 'Toplam Kalem',
    itemsCount: '{count} ürün',
    totalQuantity: 'Toplam Miktar',
    quantityCount: '{count} adet',
    total: 'Toplam',
    submit: 'Siparişi Gönder',
    submitting: 'Gönderiliyor...',
  },
  pageLoader: {
    defaultMessage: 'Veriler yükleniyor...',
    tips: {
      filters: 'Filtreleri kullanarak aradığınızı daha hızlı bulabilirsiniz.',
      darkMode: 'Karanlık modda daha az göz yorgunluğu yaşarsınız.',
      sortTables: 'Tabloları sütun başlıklarına tıklayarak sıralayabilirsiniz.',
      mobileScroll: 'Mobil cihazlarda kaydırarak daha fazla içerik görebilirsiniz.',
      quickAccess: 'Hızlı erişim menüsünden sık kullandığınız sayfalara ulaşabilirsiniz.',
      notifications: 'Bildirim ikonu üzerinden güncel uyarıları takip edebilirsiniz.',
      csvExport: 'CSV dışa aktarma ile verileri Excel\'de inceleyebilirsiniz.',
      performance: 'Performans panelinden şube kıyaslamalarını görebilirsiniz.',
    },
  },
  stockWarnings: {
    title: 'Stok Uyarıları ({count} aktif)',
    orderRef: '{product} — Sipariş #{ref}',
    detail: 'İstenen: {requested} | Mevcut: {available} | Eksik: {shortage}',
    reminder: '{count}. hatırlatma • Son: {date}',
    dismiss: 'Hatırlatmayı Kapat',
  },
  anomalyDetail: {
    branch: 'Şube',
    staff: 'Personel',
    actionType: 'İşlem Türü',
    amount: 'Tutar',
    time: 'Zaman',
    description: 'Açıklama',
    affectedProducts: 'Etkilenen Ürünler ({count})',
    changeDiff: 'Değişiklik (Önce / Sonra)',
    before: 'Önceki',
    after: 'Sonraki',
    rawData: 'Ham Veri',
  },
  warehouseStats: {
    productCount: 'Ürün Çeşidi',
    stockValue: 'Stok Değeri',
    lowStock: 'Düşük Stok',
    inactiveProduct: 'Pasif Ürün',
  },
  reportsTables: {
    branch: 'Şube',
    total: 'TOPLAM',
    cashRegisterTitle: 'Kasa Açılış & Kapanış',
    opening: 'Açılış',
    closing: 'Kapanış',
    turnover: 'Ciro',
    order: 'Sipariş',
    monthlyBranchTitle: 'Aylık Şube Özetleri',
    avgBasket: 'Ort. Sepet',
    newCustomersTitle: 'Yeni Müşteriler',
    newCustomerCount: 'Yeni Müşteri Sayısı',
    collectionStatusTitle: 'Tahsilat Durumu',
    collected: 'Tahsil Edilen',
    uncollected: 'Tahsil Edilmeyen',
    totalCol: 'Toplam',
    cmRatioTitle: 'CM Sipariş Oranları',
    cmOrder: 'CM Sipariş',
    totalOrder: 'Toplam Sipariş',
    ratio: 'Oran',
    cmHourlyTitle: 'CM Saatlik Sipariş Dağılımı',
    hour: 'Saat',
    orderCount: 'Sipariş Sayısı',
    orderTypeDiscountsTitle: 'Şube & Tür Bazlı İndirimler',
    tableDiscount: 'Masa İndirimi',
    packageDiscount: 'Paket İndirimi',
  },
  b2bProduct: {
    notForSale: 'Satışta Değil',
    noProducts: 'Henüz ürün bulunmamaktadır.',
    addToCart: 'Sepete Ekle',
    subtotal: 'Ara toplam:',
    minLabel: 'Min: {min} {unit}',
    maxSuffix: ' • Max: {max} {unit}',
    brand: 'Marka',
    selectBrand: 'Marka Seçin',
    allBrands: 'Tüm Markalar',
  },
  stepQty: {
    increaseAria: '{step} artır',
    decreaseAria: '{step} azalt',
    stepBy: '{step}\'li artış',
  },
  csvExport: { defaultLabel: 'CSV İndir' },
  menuHelpersUi: { free: 'Ücretsiz', withVariations: 'Varyasyonlu' },
  sortable: {
    dragToSort: 'Sıralamak için sürükle',
    moveUp: 'Yukarı',
    moveDown: 'Aşağı',
    toggleDetails: 'Detay',
  },
  productsToast: {
    addedToWarehouse: 'Ürün depoya da eklendi',
    warehouseFailed: 'Depo kaydı oluşturulamadı: {message}',
    unknownError: 'Bilinmeyen hata',
    errorOccurred: 'Hata oluştu',
  },
  callcenterQA: { title: 'Başvuru Cevapları' },
  auditTimelineUi: { emptyRange: 'Bu zaman aralığında log kaydı bulunamadı.' },
  errorBoundaryUi: {
    title: 'Bir şeyler ters gitti',
    description: 'Beklenmeyen bir hata oluştu. Tekrar deneyebilir veya ana sayfaya dönebilirsiniz.',
    retry: 'Yeniden dene',
    home: 'Ana sayfa',
  },
  appShell: {
    loading: 'Yükleniyor...',
    globalError: 'Bir hata oluştu. Lütfen sayfayı yenileyin.',
  },
  uiExtras: {
    sidebarToggle: 'Kenar çubuğu',
    view: 'Görüntüle',
  },
};


// Use a recursive string type so other locales can have different string values
type DeepStringRecord<T> = {
  [K in keyof T]: T[K] extends string ? string : DeepStringRecord<T[K]>;
};

export type TranslationKeys = DeepStringRecord<typeof tr>;